import { Component, Input, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions, NgbActiveModal, NgbDateStruct, NgbDateParserFormatter, NgbDateNativeAdapter, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { Meeting } from 'src/app/model/meeting.model';
import { DateService } from 'src/app/services/date.service';
import { DatePipe } from '@angular/common';
import { AppConstant } from 'src/app/config/app.constant';
import { concatMap } from 'rxjs/operators';
import { MeetingService } from 'src/app/services/meeting.service';
import { EmployeeService } from 'src/app/_Core/_Services/employee.service';

@Component({
  standalone: false,
  selector: 'app-book-new-meeting-room',
  templateUrl: './book-new-meeting-room.component.html',
  styleUrls: ['./book-new-meeting-room.component.scss']
})
export class BookNewMeetingRoomComponent implements OnInit {
  // Helper to convert NgbDate to JS Date
  private ngbDateToDate(ngbDate: any): Date {
    if (!ngbDate) return null;
    // NgbDate: {year, month, day}
    return new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
  }

  @ViewChild('datepicker') datepicker: NgbDatepicker;
  @ViewChild('dpFromDate') datePickerFrom: NgbDatepicker;
  @ViewChild('dpFromDatehour') datePickerFromHour: NgbDatepicker;

  @Input() parkMeetingRoomId: string;
  @Input() userId: string;
  @Input() meetingDayFromName: string;
  @Input() meetingDayToName: string;
  @Input() meetingRoomStartTime: string;
  @Input() meetingRoomEndTime: string;
  @Input() maintainenceStartDate: string;
  @Input() maintainenceEndDate: string;
  @Input() isMeetingRoomEdit: string;
  @Input() bookedStartDateTime: string;
  @Input() bookedEndDateTime: string;
  @Input() purpose: string;
  @Input() remarks: string;
  @Input() meetingRoomDuration: string;
  @Input() bookingTypeHourDaily: string;
  @Input() bookedByUserId: string;
  @Input() meetingRoomDurationMax: string;

  public meeting = new Meeting();

  meetingRoomDetailsTypeData: any;
  meetingRoomStartDate: any;
  meetingRoomEndDate: any;
  selectedDate: any;
  formatDate: any;
  selectedToDate: any;
  formatToDate: any;
  minDate = undefined;
  maxDate;
  popOver = null;
  model: NgbDateStruct;
  timeStamps = [];
  normalizeMinute;
  date;
  time;
  duration;
  timeToDisplay;
  meridian = false;
  disableTime: boolean = false;
  newTime: string;
  amorpm: boolean = true;
  normalizeTime;
  normalamorpm;
  display: string;
  displayDetails;
  displayDuration: string;
  displayDurationdetails;
  displayTotalTime: string;
  displayTotalTimedetails;
  valuedate: any;
  hideAllGreen: boolean = false;
  bookedData = [];
  finalTimeLineArray = [];
  finalTimeLineArrayOthers = [];
  bookingTypeId: any;
  bookingTypeName: any;
  bookingTypeIdDaily: any;
  bookingTypeNameDaily: any;
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  disabledAllDates: any;
  disabledAllDatesHours: any;
  finalBookingArray = [];
  tempDate: any;
  meetingRoomAlreadyBooked = [];
  selectedDates: NgbDateStruct[] = [];
  selectedRanges: { start: NgbDateStruct, end: NgbDateStruct }[] = [];
  isDatepickerOpen = false;
  disanledButton: boolean = false;
  selectedDateRangeModel: any;
  selectedDateRangeModelTo: any;
  currentDateToday: any;
  nextFourMonthEndDate: any;
  operationDayFrom: any;
  operationDayTo: any;
  formatedMaintenanceStartDate: any;
  formatedMaintenanceEndDate: any;
  dateRangeForDailyBooking: any;
  tempdisabledAllDatesDaily: any;
  meetingRoomBookingPurpose: any;
  meetingRoomBookingReason: any;
  listOfPurpose = [];
  reasonForOther: boolean = false;
  isReasonRequired: boolean = false;
  meetingRoomAlreadyBlockDetails = [];
  blockDateArrayPush: any;
  dateRangeForTheMeetingRoomDeatils: any;
  startDateOnlyTextValue: any;
  startDateOnlyTextValueHourly: any;
  endDateOnlyTextValue: any;
  roomCalendarBlockoutId: any;
  tempDisabledAllDatesonlyBooked: any;
  flagForMaintenanceChecking: any;
  blockStartDate: any;
  blockEndDate: any;
  previousFromDate: NgbDate | null;
  previousToDate: NgbDate | null;
  meetingRoomUserId: any;
  tempDisabledDateBookedByAdmin: any;
  bookingTypeWiseArray: any;
  getDateRangeFromCalender: any;
  messageForButtonDisable: any;

  myForm = new FormGroup({
    fromDateToBook: new FormControl(),
    toDateToBook: new FormControl(),
    fromTime: new FormControl(),
    toTime: new FormControl(),
    bookingType: new FormControl(),
    parkMeetingRoomId: new FormControl(),
    userId: new FormControl(),
    purpose: new FormControl(),
    reason: new FormControl(),
  });

  dispalyTwentyFourHourTimeFormat: string;
  dispalyTwentyFourHourTimeFormatEnd: string;
  finalMeetingRoomStartTime: string;
  finalMeetingRoomEndTime: string;
  isNextDayBooking: boolean;
  checkCurrentDateExitsOrNot: any;
  timeChecked: boolean;
  tempData: any;
  disabledAllDatesTemp: any;
  nonOperationalDates: any[];
  dateConvertToNextDate: any;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    public datepipe: DatePipe,
    private dateSrv: DateService,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private meetingService: MeetingService,
    private employeeService: EmployeeService,
    private cdr: ChangeDetectorRef,
  ) {
    this.myForm = this.formBuilder.group({
      fromDateToBook: ['', [Validators.required]],
      toDateToBook: [''],
      fromTime: [''],
      toTime: [''],
      bookingType: ['', [Validators.required]],
      // bookingType: [''], // added for block meeting
      parkMeetingRoomId: '',
      userId: '',
      purpose: ['', [Validators.required]],
      reason: [''],
    });

    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };

    // const currentmax = new Date();
    // const max = new Date(currentmax.getFullYear(), currentmax.getMonth() + 3, 0);
    // this.maxDate = {
    //   year: max.getFullYear(),
    //   month: max.getMonth() + 1,
    //   day: max.getDate(),
    // };

    const currentDate = new Date();
    const maxDate = new Date();
    maxDate.setDate(currentDate.getDate() + 90); // Add 90 days to the current date

    this.maxDate = {
      year: maxDate.getFullYear(),
      month: maxDate.getMonth() + 1, // Months are 0-indexed
      day: maxDate.getDate(),
    };
  }

  ngOnInit(): void {
    this.flagForMaintenanceChecking = 0;
    this.valuedate = 'Today,' + new Date();
    this.getFaclittyDetails();
    this.PrepareTimeStamps();
    this.initiaizeStartTime();
    this.initializeDuration();

    const today = new Date();
    const todayFormatted = this.getFormattedDate(today);
    const nextMonthEndDate = this.getNextMonthEndDate(today);
    const nextFourMonthEndDate = this.getNextFourMonthEndDate(today);

    const startDate = todayFormatted;
    const endDate = nextFourMonthEndDate;
    const operationFrom = this.meetingDayFromName;
    const operationTo = this.meetingDayToName;

    this.currentDateToday = todayFormatted;
    this.nextFourMonthEndDate = nextFourMonthEndDate;
    this.operationDayFrom = this.meetingDayFromName;
    this.operationDayTo = this.meetingDayToName;

    // pre select date
    this.startDateOnlyTextValue = this.startDateOnlyTextValueHourly = this.currentDateToday;
    this.endDateOnlyTextValue = this.currentDateToday;
    const fromDateStruct: NgbDateStruct = this.convertDateFormat([this.formatDateStringToDate(this.startDateOnlyTextValue)])[0];
    this.fromDate = NgbDate.from(fromDateStruct);
    const fromDateStructEnd: NgbDateStruct = this.convertDateFormat([this.formatDateStringToDate(this.endDateOnlyTextValue)])[0];
    this.toDate = NgbDate.from(fromDateStructEnd);
    this.previousFromDate = null;
    this.previousToDate = null;

    const nonOperationalDates = this.getDatesInRangeNonOperationalDates(this.currentDateToday, this.nextFourMonthEndDate, this.operationDayFrom, this.operationDayTo);
    const currentDate = this.currentDateToday; // Current date as a string
    const filteredDates = nonOperationalDates.filter(date => date !== currentDate);

    // if ((this.getCurrentTime() > this.meetingRoomStartTime) || (this.getCurrentTime() > this.meetingRoomEndTime)) {
    //   nonOperationalDates.push(this.getCurrentDate());
    // }

    if (this.isTimeGreaterThan(this.getCurrentTime(), this.meetingRoomStartTime) === true) {
      nonOperationalDates.push(this.getCurrentDate());
    }

    this.nonOperationalDates = this.convertDateFormat(nonOperationalDates);

    //convert date format as per calender date selected
    const dateObject = this.convertDateFormat(nonOperationalDates);
    this.disabledAllDates = this.removeDuplicateDates(dateObject);
    this.disabledAllDatesHours = this.removeDuplicateDates(dateObject);

    this.formatedMaintenanceStartDate = this.formatDateSringToDate(this.maintainenceStartDate);
    this.formatedMaintenanceEndDate = this.formatDateSringToDate(this.maintainenceEndDate);

    const dateRange = this.getDatesInRange(this.formatedMaintenanceStartDate, this.formatedMaintenanceEndDate);

    // date blocking for maintainance
    dateRange.forEach((data, index) => {
      const dateObject = this.convertDateFormat([this.formatDateStringToDate(data)]);
      // this.disabledAllDates.push(dateObject[0]);
      // this.disabledAllDatesHours.push(dateObject[0]);
    });

    this.meetingRoomBookingPurpose = '';
    this.listOfPurpose.push(
      {
        id: "Ondemand Booking",
        name: "Ondemand Booking",
      },
      {
        id: "Urgent Maintenance",
        name: "Urgent Maintenance",
      },
      {
        id: "Others",
        name: "Others",
      },
    );

    // for edit block meeting
    if (this.isMeetingRoomEdit == 'yes') {
      this.startDateOnlyTextValue = this.datepipe.transform(this.bookedStartDateTime, 'yyyy-MM-dd');
      this.startDateOnlyTextValueHourly = this.datepipe.transform(this.bookedStartDateTime, 'yyyy-MM-dd');
      console.log(this.startDateOnlyTextValue);
      console.log(this.bookedStartDateTime);
      this.endDateOnlyTextValue = this.datepipe.transform(this.bookedEndDateTime, 'yyyy-MM-dd');
      const fromDateStruct: NgbDateStruct = this.convertDateFormat([this.formatDateStringToDate(this.startDateOnlyTextValue)])[0];
      this.fromDate = NgbDate.from(fromDateStruct);
      const fromDateStructEnd: NgbDateStruct = this.convertDateFormat([this.formatDateStringToDate(this.endDateOnlyTextValue)])[0];
      this.toDate = NgbDate.from(fromDateStructEnd);
      this.roomCalendarBlockoutId = localStorage.getItem('roomCalendarBlockoutId');
      this.meetingRoomBookingPurpose = this.purpose;
      this.meetingRoomBookingReason = this.remarks;
      if (this.purpose == 'Others') {
        this.reasonForOther = true;
      } else {
        this.reasonForOther = false;
      }
      this.previousFromDate = this.fromDate;
      this.previousToDate = this.toDate;
      this.bookingTypeHourDaily = this.bookingTypeHourDaily;
    }

    this.tempDisabledAllDatesonlyBooked = [];
    this.tempDisabledDateBookedByAdmin = [];
  }

  closeDatepickerFrom(): void {
    // Check if the datepicker instance exists
    if (this.datePickerFrom) {
      new this.datePickerFrom.navigate(null); // Close the datepicker datePickerFromHour
    }
    if (this.datePickerFromHour) {
      new this.datePickerFromHour.navigate(null); // Close the datepicker datePickerFromHour
    }
  }

  onSubmit(): void {

    if (this.bookingTypeName == 'Hourly') {
      this.myForm.controls.fromDateToBook.setValue('1');
    }

    if (this.myForm.valid) {

      if (this.bookingTypeName != '') {

        this.finalBookingArray = [];

        let forDailyFromDate;
        let forDailyToDate;

        if (this.bookingTypeName == 'Hourly') {
          forDailyFromDate = this.formatter.format(this.toDate);
          if (this.isNextDayBooking === true) {
            forDailyToDate = this.addOneDay(this.formatter.format(this.toDate));
          } else {
            forDailyToDate = this.formatter.format(this.toDate);
          }

          const startDateTime = this.bookedStartDateTime;
          const starttime = (startDateTime.split("T")[1] != undefined) ? startDateTime.split("T")[1] : this.formatAMPMToTime(this.display); // "13:00:00"

          const endDateTime = this.bookedEndDateTime;
          //const endtime = (startDateTime.split("T")[1] != undefined) ? startDateTime.split("T")[1] == undefined : this.formatAMPMToTime(this.displayTotalTime); // "13:00:00"
          const endtime = (endDateTime.split("T")[1] != undefined) ? endDateTime.split("T")[1] : this.formatAMPMToTime(this.displayTotalTime); // "13:00:00"

          this.finalMeetingRoomStartTime = (this.dispalyTwentyFourHourTimeFormat == undefined) ? starttime : this.dispalyTwentyFourHourTimeFormat;
          // this.finalMeetingRoomEndTime = (this.dispalyTwentyFourHourTimeFormatEnd == undefined) ? this.addDurationToTime(endtime, this.duration) : this.dispalyTwentyFourHourTimeFormatEnd;
          this.finalMeetingRoomEndTime = (this.dispalyTwentyFourHourTimeFormatEnd == undefined) ? endtime.toString() : this.dispalyTwentyFourHourTimeFormatEnd;
        } else {
          const fromDateObj = this.ngbDateToDate(this.fromDate);
          const toDateObj = this.ngbDateToDate(this.toDate);
          forDailyFromDate = this.formatter.format(this.fromDate);
          let toDate = new Date(toDateObj);
          // Parse start and end times as Date objects on the same day
          const [startHour, startMinute] = this.meetingRoomStartTime.split(":").map(Number);
          const [endHour, endMinute] = this.meetingRoomEndTime.split(":").map(Number);
          const startDateTime = new Date(fromDateObj);
          startDateTime.setHours(startHour, startMinute, 0, 0);
          const endDateTime = new Date(toDateObj);
          endDateTime.setHours(endHour, endMinute, 0, 0);

          // If end time is less than start time, move end date to next day
          if (endDateTime <= startDateTime) {
            toDate.setDate(toDate.getDate() + 1);
          }

          // If booking is for a date range, set end time to 3AM of the day after the last selected date
          if (this.fromDate && this.toDate && (this.fromDate.year !== this.toDate.year || this.fromDate.month !== this.toDate.month || this.fromDate.day !== this.toDate.day)) {
            // If operation end time is less than start time (crosses midnight), always add a day
            const [opEndHour, opEndMinute] = (this.meetingRoomEndTime || "03:00").split(":").map(Number);
            if (opEndHour < startHour || (opEndHour === startHour && (opEndMinute || 0) < (startMinute || 0))) {
              toDate = new Date(toDateObj);
              toDate.setDate(toDate.getDate() + 1);
              endDateTime.setDate(endDateTime.getDate() + 1);
              endDateTime.setHours(opEndHour, opEndMinute || 0, 0, 0);
              this.finalMeetingRoomEndTime = this.meetingRoomEndTime || "03:00";
            } else {
              this.finalMeetingRoomEndTime = this.meetingRoomEndTime;
            }
          } else {
            this.finalMeetingRoomEndTime = this.meetingRoomEndTime;
          }

          // Convert toDate back to NgbDateStruct for formatter
          const toDateStruct = { year: toDate.getFullYear(), month: toDate.getMonth() + 1, day: toDate.getDate() };
          forDailyToDate = this.formatter.format(toDateStruct);
          this.finalMeetingRoomStartTime = this.meetingRoomStartTime;

        }

        if (this.isMeetingRoomEdit == 'yes') {
          this.bookingTypeId = this.bookingTypeHourDaily;
        }

        this.finalBookingArray.push({
          "bookingType": this.bookingTypeId,
          "parkMeetingRoomId": this.parkMeetingRoomId,
          "startDateTime": this.convertToIsoDateTime(forDailyFromDate, this.finalMeetingRoomStartTime),
          "endDateTime": this.convertToIsoDateTime(forDailyToDate, this.finalMeetingRoomEndTime),
          "roomCalendarBlockoutId": this.roomCalendarBlockoutId ? this.roomCalendarBlockoutId : null,
          "purpose": this.meetingRoomBookingPurpose,
          "remarks": this.meetingRoomBookingReason ? this.meetingRoomBookingReason : null,
          "userId": localStorage.getItem('userId')
        });
      }
      this.employeeService
        .bookNewMeetingRoom(this.finalBookingArray[0])
        .subscribe((res) => {
          this.modal.close();
          // this.modal.dismiss();
          setTimeout(() => {
            location.reload();
          }, 10000);
        });
    } else {
      Object.keys(this.myForm.controls).forEach(key => {
        if (this.myForm.controls[key].invalid) {
          console.log(`${key} is invalid`);
        }
      });
      this.myForm.markAllAsTouched();
    }
  }

  convertToIsoDateTime(dateString, timeString) {
    // Parse date string into year, month, and day parts
    const [year, month, day] = dateString.split('-').map(part => parseInt(part, 10));

    // Parse time string into hour and minute parts
    const [time, period] = timeString.split(' ');
    let [hour, minute] = time.split(':').map(part => parseInt(part, 10));

    // Adjust hour if PM and not already 12
    if (period === 'PM' && hour !== 12) {
      hour += 12;
    } else if (period === 'AM' && hour === 12) { // Adjust hour if AM and 12
      hour = 0;
    }

    // Create ISO date string
    const isoDateTime = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}T${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;

    return isoDateTime;
  }

  getFormattedDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 because month is zero-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getNextMonthEndDate(date) {
    const nextMonth = new Date(date.getFullYear(), date.getMonth() + 2, 0);
    return this.getFormattedDate(nextMonth);
  }

  getNextFourMonthEndDate(date) {
    const nextMonth = new Date(date.getFullYear(), date.getMonth() + 5, 0);
    return this.getFormattedDate(nextMonth);
  }

  convertDateFormat(dateStrings) {
    return dateStrings.map(dateString => {
      const [year, month, day] = dateString.split('-').map(Number);
      return { year, month, day };
    });
  }

  isDisabledHours = (date: NgbDateStruct) => {
    // Your logic to check if the date should be disabled
    // Example logic:
    return this.disabledAllDatesHours.some(d => this.isSameDateHours(date, d));
  }

  isDisabled = (date: NgbDateStruct) => {
    // Your logic to check if the date should be disabled
    // Example logic:
    return this.disabledAllDates.some(d => this.isSameDate(date, d));
  }

  isMinDate(date) {
    return this.minDate;
  }

  closeDatepicker(): void {
    // Set a timeout to close the datepicker asynchronously
    setTimeout(() => {
      const datepicker = document.querySelector('ngb-datepicker');
      if (datepicker) {
        datepicker.dispatchEvent(new Event('click')); // Simulate click event to close the datepicker
      }
    });
  }

  private isSameDateHours(date1: NgbDateStruct, date2: NgbDateStruct): boolean {
    return date1.year === date2.year && date1.month === date2.month && date1.day === date2.day;
  }

  private isSameDate(date1: NgbDateStruct, date2: NgbDateStruct): boolean {
    return date1.year === date2.year && date1.month === date2.month && date1.day === date2.day;
  }

  onDateSelectionMultiple(date: NgbDateStruct) {
    if (this.selectedRanges.length === 0 || this.selectedRanges.length % 2 === 0) {
      // Start new range
      this.selectedRanges.push({ start: date, end: null });
    } else {
      // Complete current range
      const lastIndex = this.selectedRanges.length - 1;
      this.selectedRanges[lastIndex].end = date;
    }
  }

  toggleDatepicker() {
    this.isDatepickerOpen = !this.isDatepickerOpen;
  }

  formatDateSringToDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 because month is zero-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  formatTime(timeString) {
    const [hour, minute] = timeString.split(':');
    const formattedHour = (parseInt(hour, 10) % 12 || 12).toString(); // Convert 0 to 12
    const period = parseInt(hour, 10) < 12 ? 'AM' : 'PM';
    return `${formattedHour}:${minute} ${period}`;
  }

  formatDateAll(dateString) {
    const parts = dateString.split('-');
    const year = parts[0];
    const month = parts[1].padStart(2, '0'); // padStart adds leading zero if necessary
    const day = parts[2].padStart(2, '0'); // padStart adds leading zero if necessary
    return `${year}-${month}-${day}`;
  }

  getMeetingRoomTimeLineDetails() {

    this.finalTimeLineArray = [];
    this.finalTimeLineArray.push({
      "bookingType": this.bookingTypeId,
      "parkMeetingRoomId": this.parkMeetingRoomId,
      "startDate": this.formatDateAll(this.selectedDate),
      "endDate": this.formatDateAll(this.selectedDate),
    });

    this.meetingRoomAlreadyBooked = [];
    this.employeeService
      .getMeetingRoomTimeLine(this.finalTimeLineArray[0])
      .subscribe((res) => {
        this.tempData = res?.data;
        this.checkCurrentDateExitsOrNot = this.isCurrentDateInBookingList(res?.data);
        this.bookingTypeWiseArray = this.filterBookingByType(res.data); //date rage from new message
        res.data.bookingTimeLineList.forEach((data, index) => {
          this.meetingRoomAlreadyBooked.push(
            {
              startTime: this.convertTimeToAMPM(data.bookedStartTime),
              endTime: this.convertTimeToAMPM(data.bookedEndTime),
            }
          );
        });
      });
  }

  selectBookingTypeId(id, name) {
    this.bookingTypeId = id;
    this.bookingTypeName = name;

    this.disanledButton = false;
    this.messageForButtonDisable = '';
    this.meetingRoomBookingPurpose = '';

    setTimeout(() => {
      this.myForm.controls.fromDateToBook.setValue('');
      this.myForm.controls.toDateToBook.setValue('');
    }, 100);

    this.meetingRoomAlreadyBooked.length = 0;

    if (this.bookingTypeName == 'Daily' || this.bookingTypeName == 'Hourly') {
      this.finalTimeLineArray = [];
      this.finalTimeLineArray.push({
        "bookingType": this.bookingTypeId,
        "parkMeetingRoomId": this.parkMeetingRoomId,
        "startDate": this.formatDateAll(this.currentDateToday),
        "endDate": this.formatDateAll(this.nextFourMonthEndDate),
      });
      this.meetingRoomAlreadyBooked = [];

      this.employeeService
        .getMeetingRoomTimeLine(this.finalTimeLineArray[0])
        .subscribe((res) => {
          this.tempData = res?.data;
          this.checkCurrentDateExitsOrNot = this.isCurrentDateInBookingList(res?.data);
          this.bookingTypeWiseArray = this.filterBookingByType(res.data); //date rage from new message
          this.disabledAllDates.push(
            ...res.data.bookingTimeLineList.flatMap((data) =>
              this.getDatesInRange(
                this.formatDateSringToDate(data.bookedStartDate),
                this.formatDateSringToDate(data.bookedEndDate)
              ).map((date) => this.convertDateFormat([this.formatDateStringToDate(date)])[0])
            )
          );

          this.tempDisabledAllDatesonlyBooked.push(
            ...res.data.bookingTimeLineList.flatMap((data) =>
              this.getDatesInRange(
                this.formatDateSringToDate(data.bookedStartDate),
                this.formatDateSringToDate(data.bookedEndDate)
              ).map((date) => this.convertDateFormat([this.formatDateStringToDate(date)])[0])
            )
          );

          this.disabledAllDates = this.removeDuplicateDates(this.disabledAllDates);
          this.tempDisabledAllDatesonlyBooked = this.removeDuplicateDates(this.tempDisabledAllDatesonlyBooked);
          this.disabledAllDatesHours = this.disabledAllDates; // changes for hourly booking

          const isGivenDateExits = this.isDateBlocked(this.calformatDate(this.toDate), this.tempData);
          if (!isGivenDateExits && this.bookingTypeName == 'Hourly') {
            this.disabledAllDates = this.removeCurrentDate(this.disabledAllDates);
          }
          if (this.bookingTypeName == 'Hourly') {
            this.disabledAllDates = this.processHourlyBookings(this.tempData, this.disabledAllDates);
            this.disabledAllDates = this.removeScheduleMaintenance(this.disabledAllDates, this.tempData);
          }
        });
    }
  }

  selectBookingTypeIdForBlock(id, name, idHourly, nameHourly) {
    // this.bookingTypeWiseArray = [];
    this.bookingTypeId = idHourly;
    this.bookingTypeName = nameHourly;

    this.bookingTypeIdDaily = id;
    this.bookingTypeNameDaily = name;

    this.myForm.controls.fromDateToBook.setValue('');
    this.myForm.controls.toDateToBook.setValue('');

    this.meetingRoomAlreadyBooked.length = 0;

    this.finalTimeLineArray = [];
    this.finalTimeLineArray.push({
      "bookingType": this.bookingTypeIdDaily,
      "parkMeetingRoomId": this.parkMeetingRoomId,
      "startDate": this.formatDateAll(this.currentDateToday),
      "endDate": this.formatDateAll(this.nextFourMonthEndDate),
    });

    this.finalTimeLineArrayOthers = [];
    this.finalTimeLineArrayOthers.push({
      "bookingType": this.bookingTypeId,
      "parkMeetingRoomId": this.parkMeetingRoomId,
      "startDate": this.formatDateAll(this.currentDateToday),
      "endDate": this.formatDateAll(this.nextFourMonthEndDate),
    });

    this.employeeService
      .getMeetingRoomTimeLine(this.finalTimeLineArray[0])
      .subscribe((res) => {
        this.tempData = res?.data;
        this.checkCurrentDateExitsOrNot = this.isCurrentDateInBookingList(res?.data);
        this.bookingTypeWiseArray = this.filterBookingByType(res.data); //date rage from new message
        this.disabledAllDates.push(
          ...res.data.bookingTimeLineList.flatMap((data) =>
            this.getDatesInRange(
              this.formatDateSringToDate(data.bookedStartDate),
              this.formatDateSringToDate(data.bookedEndDate)
            ).map((date) => this.convertDateFormat([this.formatDateStringToDate(date)])[0])
          )
        );

        this.tempDisabledAllDatesonlyBooked.push(
          ...res.data.bookingTimeLineList.flatMap((data) =>
            this.getDatesInRange(
              this.formatDateSringToDate(data.bookedStartDate),
              this.formatDateSringToDate(data.bookedEndDate)
            ).map((date) => this.convertDateFormat([this.formatDateStringToDate(date)])[0])
          )
        );

        this.disabledAllDates = this.removeDuplicateDates(this.disabledAllDates);
        this.tempDisabledAllDatesonlyBooked = this.removeDuplicateDates(this.tempDisabledAllDatesonlyBooked);
        this.disabledAllDatesHours = this.disabledAllDates; // changes for hourly booking

        const isGivenDateExits = this.isDateBlocked(this.calformatDate(this.toDate), this.tempData);
        if (!isGivenDateExits && this.bookingTypeName == 'Hourly') {
          this.disabledAllDatesTemp = this.disabledAllDates;
          this.disabledAllDates = this.removeCurrentDate(this.disabledAllDates);
        }
        if (this.bookingTypeName == 'Hourly') {
          this.disabledAllDates = this.processHourlyBookings(this.tempData, this.disabledAllDates);
          this.disabledAllDates = this.removeScheduleMaintenance(this.disabledAllDates, this.tempData);
        }
      });

    this.employeeService
      .getMeetingRoomTimeLine(this.finalTimeLineArrayOthers[0])
      .subscribe((res) => {
        this.tempData = res?.data;
        this.checkCurrentDateExitsOrNot = this.isCurrentDateInBookingList(res?.data);
        this.bookingTypeWiseArray = this.filterBookingByType(res.data); //date rage from new message
        this.disabledAllDates.push(
          ...res.data.bookingTimeLineList.flatMap((data) =>
            this.getDatesInRange(
              this.formatDateSringToDate(data.bookedStartDate),
              this.formatDateSringToDate(data.bookedEndDate)
            ).map((date) => this.convertDateFormat([this.formatDateStringToDate(date)])[0])
          )
        );

        this.tempDisabledAllDatesonlyBooked.push(
          ...res.data.bookingTimeLineList.flatMap((data) =>
            this.getDatesInRange(
              this.formatDateSringToDate(data.bookedStartDate),
              this.formatDateSringToDate(data.bookedEndDate)
            ).map((date) => this.convertDateFormat([this.formatDateStringToDate(date)])[0])
          )
        );

        this.disabledAllDates = this.removeDuplicateDates(this.disabledAllDates);
        this.tempDisabledAllDatesonlyBooked = this.removeDuplicateDates(this.tempDisabledAllDatesonlyBooked);
        this.disabledAllDatesHours = this.disabledAllDates; // changes for hourly booking

        const isGivenDateExits = this.isDateBlocked(this.calformatDate(this.toDate), this.tempData);
        if (!isGivenDateExits && this.bookingTypeName == 'Hourly') {
          this.disabledAllDatesTemp = this.disabledAllDates;
          this.disabledAllDates = this.removeCurrentDate(this.disabledAllDates);
        }
        if (this.bookingTypeName == 'Hourly') {
          this.disabledAllDates = this.processHourlyBookings(this.tempData, this.disabledAllDates);
          this.disabledAllDates = this.removeScheduleMaintenance(this.disabledAllDates, this.tempData);
        }

        // when page load
        this.dateRangeForDailyBooking = [];
        this.dateRangeForDailyBooking = this.getDateRangeAndFormat(this.formatter.format(this.fromDate), this.formatter.format(this.toDate));
        this.tempdisabledAllDatesDaily = [];
        this.tempdisabledAllDatesDaily = this.convertToDateStrings(this.tempDisabledAllDatesonlyBooked); // disabledAllDates

        const uniqueDates = this.findUniqueDates(this.convertToDateStrings(this.tempDisabledDateBookedByAdmin), this.tempdisabledAllDatesDaily);

        const blockedBookings = this.checkForBlockedDates(this.dateRangeForDailyBooking, uniqueDates);
        if (blockedBookings) {
          //this.disanledButton = true;
          this.flagForMaintenanceChecking = 1;
        } else {
          // this.disanledButton = false;
          this.flagForMaintenanceChecking = 0;
        }
      });
    this.getAllBlockDateMeetingRoom();

    if (this.isMeetingRoomEdit == 'yes') {
      this.bookingTypeName = this.getBookingTypeNameById(this.meetingRoomDetailsTypeData, this.bookingTypeHourDaily);
    }
  }

  formatDateStringToDate(dateString) {
    // Extract the date part (first 10 characters)
    return dateString.substring(0, 10);
  }

  getFaclittyDetails() {
    this.employeeService.fetchFacilityBookingTypes().subscribe((res) => {
      this.meetingRoomDetailsTypeData = res?.list;

      // this.myForm.controls.bookingType.setValue(this.meetingRoomDetailsTypeData[0].facilityBookingTypeId);

      this.bookingTypeId = this.meetingRoomDetailsTypeData[0].facilityBookingTypeId;
      this.bookingTypeName = this.meetingRoomDetailsTypeData[0].bookingTypeName;

      // added for block meeting
      this.bookingTypeIdDaily = this.meetingRoomDetailsTypeData[1].facilityBookingTypeId;
      this.bookingTypeNameDaily = this.meetingRoomDetailsTypeData[1].bookingTypeName;

      this.bookingTypeIdDaily = this.bookingTypeId;
      this.bookingTypeNameDaily = this.bookingTypeName;

      if (this.isMeetingRoomEdit != 'yes') {
        this.bookingTypeHourDaily = this.bookingTypeId;
      }

      // added for block meeting
      this.selectBookingTypeIdForBlock(this.bookingTypeIdDaily, this.bookingTypeNameDaily, this.bookingTypeId, this.bookingTypeName);

      this.cdr.detectChanges();
    });
  }

  // setBookingType(id: string) {
  //   const selectedType = this.meetingRoomDetailsTypeData.find(item => item.facilityBookingTypeId === id);
  //   if (selectedType) {
  //     this.bookingTypeHourDaily = selectedType.facilityBookingTypeId;
  //     this.myForm.get('bookingType')?.setValue(id); // Set value in the form
  //   }
  // }

  getBookingTypeNameById(arr, id) {
    const item = arr.find(entry => entry.facilityBookingTypeId === id);
    return item ? item.bookingTypeName : null;
  }

  openPopOver() {
    if (this.previousFromDate == null && this.previousToDate == null) {
      // this.clearDateRange();
    }
    // need open later
    // const current = new Date();
    // this.minDate = {
    //   year: current.getFullYear(),
    //   month: current.getMonth() + 1,
    //   day: current.getDate(),
    // };
  }

  openPopOverHourly() {
    if (this.bookingTypeName == 'Hourly') {
      this.fromDate = this.toDate;
    }
  }

  onDateSelection(date: NgbDate) {
    this.clearDateRangePrevious();

    this.getDateRangeFromCalender = this.getDateRange(this.calformatDate(this.fromDate), this.calformatDate(date));
    this.meetingRoomBookingPurpose = '';
    this.messageForButtonDisable = '';

    this.previousFromDate = this.fromDate;
    this.previousToDate = this.toDate;

    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
      this.toDate = date; //remove toDate
    } else if (this.fromDate && this.toDate && date && date.after(this.fromDate)) { // add not sign(!) before toDate
      this.toDate = date;
    } else {
      this.toDate = date; // null
      this.fromDate = date;
    }
    this.myForm.controls.fromDateToBook.setValue(this.formatter.format(this.fromDate));
    this.myForm.controls.toDateToBook.setValue(this.formatter.format(this.toDate));

    // this.startDateOnlyTextValue = this.datepipe.transform(this.formatter.format(this.fromDate), 'YYYY-MM-dd');
    // this.endDateOnlyTextValue = this.datepipe.transform(this.formatter.format(this.toDate), 'YYYY-MM-dd');
    // const fromDateStruct: NgbDateStruct = this.convertDateFormat([this.formatDateStringToDate(this.startDateOnlyTextValue)])[0];
    // this.fromDate = NgbDate.from(fromDateStruct);
    // const fromDateStructEnd: NgbDateStruct = this.convertDateFormat([this.formatDateStringToDate(this.endDateOnlyTextValue)])[0];
    // this.toDate = NgbDate.from(fromDateStructEnd);

    this.dateRangeForDailyBooking = [];
    this.dateRangeForDailyBooking = this.getDateRangeAndFormat(this.formatter.format(this.fromDate), this.formatter.format(this.toDate));
    this.tempdisabledAllDatesDaily = [];
    this.tempdisabledAllDatesDaily = this.convertToDateStrings(this.tempDisabledAllDatesonlyBooked); // disabledAllDates

    const uniqueDates = this.findUniqueDates(this.convertToDateStrings(this.tempDisabledDateBookedByAdmin), this.tempdisabledAllDatesDaily);

    const blockedBookings = this.checkForBlockedDates(this.dateRangeForDailyBooking, uniqueDates);
    if (blockedBookings) {
      // this.disanledButton = true; // closed for checking new message
      this.flagForMaintenanceChecking = 1;
    } else {
      // this.disanledButton = false; // closed for checking new message
      this.flagForMaintenanceChecking = 0;
    }

    if (this.meetingRoomBookingPurpose == 'Urgent Maintenance') {
      // this.disanledButton = false; // closed for checking new message
    } else {
      if (this.flagForMaintenanceChecking == 1) {
        // this.disanledButton = true; // closed for checking new message
      } else {
        // this.disanledButton = false; // closed for checking new message
      }
    }

    // this.closeDatepickerFrom();
  }

  findUniqueDates(array1, array2) {
    const uniqueInArray1 = array1.filter(date => !array2.includes(date.trim()));
    const uniqueInArray2 = array2.filter(date => !array1.includes(date.trim()));
    return [...uniqueInArray1, ...uniqueInArray2];
  }

  onDateSelectionFrom(date: NgbDate) {
    this.clearDateRangePrevious();

    if (this.bookingTypeName == 'Hourly') {
      this.fromDate = date;
    }

    if (this.toDate && this.fromDate && this.previousToDate && this.previousFromDate) {
      if ((this.previousToDate.day != date.day)) {
        this.fromDate = null;
        this.toDate = null;
      }
    }

    this.previousFromDate = this.fromDate;
    this.previousToDate = this.toDate;

    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
      this.toDate = date; //remove toDate
    } else if (this.fromDate && this.toDate && date && date.after(this.fromDate)) { // add not sign(!) before toDate
      this.toDate = date;
    } else {
      this.toDate = date; // null
      this.fromDate = date;
    }

    if (this.bookingTypeName == 'Hourly') {
      this.getDateRangeFromCalender = this.getDateRange(this.calformatDate(this.toDate), this.calformatDate(this.toDate));
    } else {
      this.getDateRangeFromCalender = this.getDateRange(this.calformatDate(this.fromDate), this.calformatDate(this.toDate));
    }

    this.meetingRoomBookingPurpose = '';
    this.messageForButtonDisable = '';

    this.myForm.controls.fromDateToBook.setValue(this.formatter.format(this.fromDate));
    this.myForm.controls.toDateToBook.setValue(this.formatter.format(this.toDate));

    // this.startDateOnlyTextValue = this.datepipe.transform(this.formatter.format(this.fromDate), 'YYYY-MM-dd');
    // this.endDateOnlyTextValue = this.datepipe.transform(this.formatter.format(this.toDate), 'YYYY-MM-dd');
    // const fromDateStruct: NgbDateStruct = this.convertDateFormat([this.formatDateStringToDate(this.startDateOnlyTextValue)])[0];
    // this.fromDate = NgbDate.from(fromDateStruct);
    // const fromDateStructEnd: NgbDateStruct = this.convertDateFormat([this.formatDateStringToDate(this.endDateOnlyTextValue)])[0];
    // this.toDate = NgbDate.from(fromDateStructEnd);

    this.dateRangeForDailyBooking = [];
    this.dateRangeForDailyBooking = this.getDateRangeAndFormat(this.formatter.format(this.fromDate), this.formatter.format(this.toDate));
    this.tempdisabledAllDatesDaily = [];
    this.tempdisabledAllDatesDaily = this.convertToDateStrings(this.tempDisabledAllDatesonlyBooked); // disabledAllDates

    const uniqueDates = this.findUniqueDates(this.convertToDateStrings(this.tempDisabledDateBookedByAdmin), this.tempdisabledAllDatesDaily);

    const blockedBookings = this.checkForBlockedDates(this.dateRangeForDailyBooking, uniqueDates);
    if (blockedBookings) {
      // this.disanledButton = true; // closed for checking new message
      this.flagForMaintenanceChecking = 1;
    } else {
      // this.disanledButton = false; // closed for checking new message
      this.flagForMaintenanceChecking = 0;
    }

    if (this.meetingRoomBookingPurpose == 'Urgent Maintenance') {
      // this.disanledButton = false; // closed for checking new message
    } else {
      if (this.flagForMaintenanceChecking == 1) {
        // this.disanledButton = true; // closed for checking new message
      } else {
        // this.disanledButton = false; // closed for checking new message
      }
    }

    // this.minDate = this.fromDate; // need open later
    // this.closeDatepickerFrom();
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

  clearDateRange(): void {
    this.fromDate = null;
    this.toDate = null;
  }

  clearDateRangePrevious(): void {
    // if (this.isMeetingRoomEdit == 'yes') {
    //   this.fromDate = null;
    //   this.toDate = null;
    // }
    // this.isMeetingRoomEdit = 'no';
  }

  onDateRangeSelect(): void {
    // Check if the current selection is different from the previous one
    if (this.fromDate !== this.previousFromDate || this.toDate !== this.previousToDate) {
      // Clear the previous selection only if it exists
      if (this.previousFromDate && this.previousToDate) {
        this.clearPreviousDateRange();
      }
    }
    // Update the previous selection with the current one
    this.previousFromDate = this.fromDate;
    this.previousToDate = this.toDate;
  }

  clearPreviousDateRange(): void {
    this.fromDate = null;
    this.toDate = null;
  }

  public updateSelectedDate(date: NgbDate) {
    this.meetingRoomStartDate = date.year + '-' + date.month + '-' + date.day;
    this.meetingRoomStartDate = this.datepipe.transform(this.meetingRoomStartDate, 'yyyy-MM-dd');
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.selectedDate = this.convertFormat(date.year, date.month, date.day);
    this.formatDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
    this.getMeetingRoomTimeLineDetails();
  }

  public async updateSelectedToDate(date: NgbDate) {
    this.meetingRoomEndDate = date.year + '-' + date.month + '-' + date.day;
    this.meetingRoomEndDate = this.datepipe.transform(this.meetingRoomEndDate, 'yyyy-MM-dd');
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.selectedToDate = this.convertFormat(date.year, date.month, date.day);

    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    this.formatToDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
  }

  convertFormat(y, m, d) {
    return y + '-' + m + '-' + d;
  }

  getDateinNgbFormat(date) {
    let dt = (date.split('T')[0]).split('-')
    let fDate = {
      year: parseInt(dt[0]),
      month: parseInt(dt[1]),
      day: parseInt(dt[2])
    }
    return fDate
  }

  public onClickedOutside(e: Event) {
  }

  public openPopover(popover, inputTime) {
    this.popOver = popover;
    if (popover.isOpen())
      popover.close();
    else
      popover.open();
  }

  public PrepareTimeStamps() {
    let StartTimeForSlot = 0;
    while (StartTimeForSlot <= 24) {
      this.timeStamps.push(StartTimeForSlot)
      StartTimeForSlot += 0.5
    }
  }

  getNormalizeMinute(iminute) {
    if (iminute > 0 && iminute <= 15) {
      this.normalizeMinute = 15
    }
    else if (iminute > 15 && iminute <= 30) {
      this.normalizeMinute = 30
    }
    else if (iminute > 30 && iminute <= 45) {
      this.normalizeMinute = 45;
    }
    else if (iminute > 45 && iminute <= 60) {
      this.normalizeMinute = 0;
    }
    else {
      this.normalizeMinute = 0;
    }
  }


  /**
   * Initializes the start time for booking a new meeting room.
   * 
   * This method performs the following steps:
   * 1. Logs the current time in both formatted and 24-hour formats.
   * 2. Rounds the current time to the next segment and logs it.
   * 3. Initializes the `date` and `timeToDisplay` properties with the current date and time.
   * 4. Extracts the current hour, minute, and period (AM/PM) from the formatted current time.
   * 5. Determines the hour and minute to be used for the start time, either from local storage or the current time.
   * 6. Sets the `disableTime` flag if the combined hour and minute exceed 7.
   * 7. Normalizes the minute value and adjusts the hour if necessary.
   * 8. Determines the period (AM/PM) to be used, based on the current time or local storage.
   * 9. Sets the `amorpm` flag to true if the period is PM, otherwise false.
   * 10. Normalizes the time to a 24-hour format based on the `amorpm` flag.
   * 11. Formats the minute value to ensure it is two digits.
   * 12. Sets the `display` and `displayDetails` properties with the formatted time and period.
   * 13. Logs the normalized time and `amorpm` flag.
   * 
   * Dependencies:
   * - `getCurrentTimeFormatted()`: Returns the current time in a formatted string.
   * - `getCurrentTime24Hour()`: Returns the current time in 24-hour format.
   * - `roundToNextSegment(time: string)`: Rounds the given time to the next segment.
   * - `splitTime(time: string)`: Splits the given time string into hours, minutes, and period.
   * - `getNormalizeMinute(minute: number)`: Normalizes the given minute value.
   * 
   * @returns {void}
   */
  initiaizeStartTime() {

    let amorpm;
    // this.timer = setInterval(() => {
    this.date = new Date();
    this.timeToDisplay = new Date();

    let currentHourFromCurrentTime = this.splitTime(this.getCurrentTimeFormatted()).hours ?? 7;
    let currentMinuteFromCurrentTime = this.splitTime(this.getCurrentTimeFormatted()).minutes ?? 0;
    let currentPeriod = this.splitTime(this.getCurrentTimeFormatted()).period ?? 'AM';

    let changeHour = Number(currentHourFromCurrentTime); // Number(localStorage.getItem(AppConstant.localStorage.changeHour));
    let changeMinute = Number(currentMinuteFromCurrentTime); //Number(localStorage.getItem(AppConstant.localStorage.changeMinute));
    let changeamorpm = currentPeriod; // localStorage.getItem(AppConstant.localStorage.changeamorpm);
    let hour = (changeHour || changeMinute) ? changeHour : this.timeToDisplay.getHours();
    let minute = (changeHour || changeMinute) ? changeMinute : this.timeToDisplay.getMinutes();
    let currenthour = hour == 0 ? 12 : hour;

    if (currenthour + minute > 7)
      this.disableTime = true;
    this.time = { hour: currenthour, minute: minute };
    this.newTime = `${this.time.hour}:${this.time.minute}`;
    this.getNormalizeMinute(this.time.minute);
    let normalizeHour = (this.normalizeMinute == 0 && minute != 0) ? this.time.hour + 1 : this.time.hour;
    normalizeHour = normalizeHour >= 13 ? normalizeHour - 12 : normalizeHour;
    if (changeamorpm.toLowerCase() == 'am' || changeamorpm.toLowerCase() == 'pm') {
      amorpm = changeamorpm;
    } else if (changeamorpm == 'null') {
      if (hour != 0 && (currenthour >= 12 || normalizeHour == 12)) {
        amorpm = 'pm';
      }
      else {
        amorpm = 'am';
      }
    } else {
      amorpm = changeamorpm;
    }

    this.amorpm = amorpm.toLowerCase() == 'pm' ? true : false;
    this.newTime = `${this.time.hour}:${this.time.minute}`;
    // normalizeHour = 12;
    if (this.amorpm === true) {
      // this.normalizeTime = { hour: (this.amorpm === true && normalizeHour == 12) ? 12 : normalizeHour + 12, minute: this.normalizeMinute };
      this.normalizeTime = { hour: (this.amorpm === true && normalizeHour == 12) ? 12 : normalizeHour, minute: this.normalizeMinute };
    } else {
      this.normalizeTime = { hour: normalizeHour, minute: this.normalizeMinute };
    }

    this.normalamorpm = amorpm;
    let len = this.normalizeTime.minute.toString().length;
    if (len == 1) {
      minute = '0' + this.normalizeTime.minute;
    }
    else {
      minute = this.normalizeTime.minute;
    }

    if (this.getCurrentTime24Hour().split(':')[0] == '23' && amorpm == 'PM') {
      amorpm = 'AM';
      this.amorpm = false;
    } else if (this.getCurrentTime24Hour().split(':')[0] == '11' && amorpm == 'AM') {
      amorpm = 'PM';
      this.amorpm = true;
    } else if (this.getCurrentTime24Hour().split(':')[0] == '00' && amorpm == 'AM') {
      amorpm = 'AM';
      this.amorpm = false;
    } else {
      amorpm = amorpm;
      this.amorpm = this.amorpm;
    }

    this.display = this.time.hour >= 13 ? normalizeHour + ':' + minute + ' ' + amorpm : normalizeHour + ':' + minute + ' ' + amorpm;
    this.displayDetails = this.time.hour >= 13 ? normalizeHour + ':' + minute + ' ' + amorpm : normalizeHour + ':' + minute + ' ' + amorpm.toUpperCase();

    if (this.isMeetingRoomEdit == 'yes') {
      let newEditedTime = this.splitTime12HourFormat(this.convertTo12HourFormat(this.bookedStartDateTime));
      this.display = this.displayDetails = newEditedTime.hours + ':' + newEditedTime.minutes + ' ' + newEditedTime.period;

      if (newEditedTime.period === 'PM') {
        // this.normalizeTime = { hour: (newEditedTime.period === 'PM' && parseInt(newEditedTime.hours) == 12) ? 12 : parseInt(newEditedTime.hours) + 12, minute: parseInt(newEditedTime.minutes) };
        this.normalizeTime = { hour: (newEditedTime.period === 'PM' && parseInt(newEditedTime.hours) == 12) ? 12 : parseInt(newEditedTime.hours), minute: parseInt(newEditedTime.minutes) };
      } else {
        this.normalizeTime = { hour: parseInt(newEditedTime.hours), minute: parseInt(newEditedTime.minutes) };
      }
      this.normalamorpm = newEditedTime.period;
    }
  }

  initializeDuration() {
    let amorpm;
    let min;

    let durationInHours;
    let durationInMinutes;

    this.meetingRoomDurationMax = localStorage.getItem('meetingRoomMaxDuration');

    if (this.isMeetingRoomEdit == 'yes') {
      let finalDuration = this.calculateTimeDifference(this.bookedStartDateTime, this.bookedEndDateTime);
      if (finalDuration < 1) {
        durationInHours = 0;
        durationInMinutes = 30;
      } else if (finalDuration == 1) {
        durationInHours = Number(finalDuration);
        durationInMinutes = 0;
      } else if (finalDuration > 1) {
        let mainDuration = finalDuration.toString().split('.');
        durationInHours = Number(mainDuration[0]);
        durationInMinutes = (mainDuration[1] == '5') ? 30 : 0;
      }
    } else {
      if (this.meetingRoomDuration < '1') {
        durationInHours = 0;
        durationInMinutes = 30;
      } else if (this.meetingRoomDuration == '1') {
        durationInHours = Number(this.meetingRoomDuration);
        durationInMinutes = 0;
      } else if (this.meetingRoomDuration > '1') {
        let mainDuration = this.meetingRoomDuration.toString().split('.');
        durationInHours = Number(mainDuration[0]);
        durationInMinutes = (mainDuration[1] == '5') ? 30 : 0;
      }
    }

    this.duration = {
      hour: durationInHours,
      minute: durationInMinutes,
      second: 0
    };

    let normalizedurationHour = this.duration.hour == 1 ? this.duration.hour + ' hour' : this.duration.hour + ' hours'
    let normalizeMinutes = this.duration.minute == 0 ? '' : this.duration.minute + ' minutes'
    this.displayDuration = normalizedurationHour + ' ' + normalizeMinutes;
    if (this.duration.minute == 0) {
      let c = 0o0
    }
    else {
      let c = "bye"
    }
    this.displayDurationdetails = this.duration.hour + '.' + (this.duration.minute <= 0 ? "0" + this.duration.minute : this.duration.minute);

    // this.time = {hour: this.timeToDisplay.getHours(), minute: this.timeToDisplay.getMinutes()};
    // this.date= this.timeToDisplay.toLocaleTimeString('en-US')

    let hour = parseInt(this.duration.hour) + parseInt(this.normalizeTime.hour);
    //let minutes = parseInt(this.duration.minute) + parseInt(this.normalizeTime.minute)-60;
    let minutes = parseInt(this.duration.minute) + parseInt(this.normalizeTime.minute);

    if (minutes >= 60) {
      hour = hour + 1
    }

    let normalizeDisplayTime = hour >= 13 ? hour - 12 : hour

    if (this.normalamorpm == 'am') {
      amorpm = 'am';
    }
    else {
      amorpm = 'pm';
    }
    amorpm = hour >= 12 ? amorpm : this.normalamorpm;

    if (minutes <= 0) {
      min = "0" + minutes
    }
    else {
      min = minutes;
    }

    if (this.amorpm == true) {
      this.normalamorpm = 'pm';
    } else {
      this.normalamorpm = 'am';
    }

    if (this.normalizeTime.hour >= 12 && (this.normalamorpm == 'am' || this.normalamorpm == 'AM'))
      amorpm = 'am';
    if (this.normalizeTime.hour >= 12 && (this.normalamorpm == 'pm' || this.normalamorpm == 'PM'))
      amorpm = 'pm';

    this.displayTotalTime = this.calculateEndTime(this.display, this.duration); // normalizeDisplayTime + ':' + ((minutes <= 0 || minutes == 60) ? "00" : (minutes > 60) ? minutes - 60 : minutes) + ' ' + amorpm.toUpperCase();
    //this.displayTotalTimedetails = normalizeDisplayTime + ':' + min + ' ' + amorpm.toUpperCase();
    this.displayTotalTimedetails = normalizeDisplayTime + ':' + ((minutes <= 0 || minutes == 60) ? "00" : (minutes > 60) ? minutes - 60 : minutes) + ' ' + amorpm.toUpperCase();

    // if ((Number(this.displayTotalTimedetails.split(' ')[0].split(':')[0]) == 12 && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'am') || (Number(this.displayTotalTimedetails.split(' ')[0].split(':')[0]) == 11 && Number(this.displayTotalTimedetails.split(' ')[0].split(':')[1]) > 45 && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'pm')) {
    //   this.appStateSrv.showToast("Meeting time cannot exceed 11:45PM. Please select the valid time.")
    //   return;
    // }

    if (this.bookingTypeName == 'Hourly') {
      const isEndTimeValid = this.isStartSmallerThanEnd(this.convertTo24HourFormat(this.displayTotalTime), this.convertTo24HourFormat(this.meetingRoomEndTime));
      this.disanledButton = isEndTimeValid;
    }


    if (!this.checkIfValidTimeline(this.displayTotalTimedetails, this.displayDetails))
      return
  }

  initializeSlider() {
    const current = new Date();
    if (current.getHours() >= 12) {
      this.amorpm = true;
    }
    else {
      this.amorpm = false;
    }
  }

  checkIfValidTimeline(toTime, startTime) {
    return true;
  }

  validateTime(event) {
    const today = new Date();
    return true;
  }

  onTimeChange(event) {
    let minute
    let amorpm: any;
    this.time = {
      hour: event.hour,
      minute: event.minute
    };
    event.minute = event.minute > 60 ? 0 : event.minute;
    if (event.minute % 15 !== 0) {
      if (event.minute < 15)
        event.minute = 15;
      else if (event.minute > 15 && event.minute < 30)
        event.minute = 30;
      else if (event.minute > 30 && event.minute < 45)
        event.minute = 45;
      else if (event.minute > 45 && event.minute < 60) {
        event.minute = 0
        event.hour++;
      }
    }

    event.hour = event.hour > 12 ? event.hour - 12 : event.hour;
    let normalizeHour = event.hour > 12 ? event.hour - 12 : event.hour;
    // if (normalizeHour == 12 && !this.amorpm && Number(this.displayDetails.split(':')[0]) !== 1)
    //   this.amorpm = true;
    if ((Number(this.displayDetails.split(':')[0]) == 12 && normalizeHour == 11) || (Number(this.displayDetails.split(':')[0]) == 11 && (normalizeHour == 12 || normalizeHour == 0)))
      this.amorpm = !this.amorpm;
    if (this.amorpm) {
      amorpm = 'pm';
    }
    else {
      amorpm = 'am';
    }

    this.getNormalizeMinute(event.minute);
    let len = event.minute.toString().length;
    if (len == 1) {
      minute = '0' + event.minute;
    }
    else {
      minute = event.minute;
    }
    this.normalamorpm = amorpm;
    this.normalizeTime.hour = normalizeHour;
    normalizeHour = normalizeHour == 0 ? 12 : normalizeHour;
    this.display = event.hour >= 13 ? normalizeHour + ':' + minute + ' ' + amorpm.toUpperCase() : normalizeHour + ':' + minute + ' ' + amorpm.toUpperCase();
    this.displayDetails = event.hour >= 13 ? normalizeHour + ':' + minute + ' ' + amorpm.toUpperCase() : normalizeHour + ':' + minute + ' ' + amorpm.toUpperCase();

    // let duration = this.duration;

    this.newTime = `${event.hour}:${event.minute}`;

    this.dispalyTwentyFourHourTimeFormat = (this.convertTo24HourFormat(this.displayDetails) == undefined) ? this.roundToNextSegment(this.getCurrentTime24Hour()) : this.convertTo24HourFormat(this.displayDetails);

    // added for hourly booking
    if (amorpm === true) {
      // this.normalizeTime = { hour: (amorpm === true && normalizeHour == 12) ? 12 : normalizeHour + 12, minute: minute };
      this.normalizeTime = { hour: (amorpm === true && normalizeHour == 12) ? 12 : normalizeHour, minute: minute };
    } else {
      this.normalizeTime = { hour: normalizeHour, minute: parseInt(minute) };
    }

    this.onDurationChange(this.duration);
  }


  toggleAmPmSelection(value: boolean) {
    this.amorpm = value;
    this.onTimeChange(this.normalizeTime);
  }

  onDurationChange(event) {
    // if (event.hour < 13) {
    if (event.hour == 0) {
      event.hour = 0;
    }

    event.hour = event.hour >= 13 ? event.hour - 12 : event.hour;
    if (event.hour == 12) {
      event.minute = 0
    }

    let amorpm;
    let minute;
    let min;

    this.duration = {
      hour: event.hour,
      minute: event.minute,
      second: 0
    };

    event.minute = event.minute > 60 ? 0 : event.minute;
    if (event.minute % 15 !== 0) {
      if (event.minute < 15)
        event.minute = 15;
      else if (event.minute > 15 && event.minute < 30)
        event.minute = 30;
      else if (event.minute > 30 && event.minute < 45)
        event.minute = 45;
      else if (event.minute > 45 && event.minute < 60) {
        event.minute = 0
        event.hour++;
      }
    }
    // event.hour = event.hour > 12 ? event.hour - 12 : event.hour;

    let normalizeHour = event.hour == 1 ? event.hour + ' hour' : event.hour + ' hours'
    let normalizeMinutes = event.minute == 0 ? '' : event.minute + ' minutes'
    this.displayDuration = normalizeHour + ' ' + normalizeMinutes;
    this.displayDurationdetails = event.hour + ':' + (event.minute <= 10 ? "0" + event.minute : event.minute);
    this.displayDurationdetails = event.hour + '.' + event.minute;

    // this.newTime=`${event.hour}:${event.minute}`;
    let hour = parseInt(event.hour) + parseInt(this.normalizeTime.hour);
    let minutes = parseInt(event.minute) + parseInt(this.normalizeTime.minute);
    if (minutes > 60) {
      hour = hour + 1
    }
    let normalizeDisplayTime = hour >= 12 ? hour - 12 : hour

    if (hour == 12 && minutes < 60) {
      normalizeDisplayTime = hour
    }

    if (minutes == 60) {
      minutes = 0;
      normalizeDisplayTime = normalizeDisplayTime + 1;
    }

    minutes = minutes >= 60 ? minutes - 60 : minutes;

    if (this.normalamorpm == 'am') {
      amorpm = 'pm';
    }
    else {
      amorpm = 'am';
    }

    amorpm = hour >= 12 ? amorpm : this.normalamorpm;
    let len = minutes.toString().length;

    if (len == 1) {
      minute = '0' + minutes;
    }
    else {
      minute = minutes;
    }

    if (minutes <= 10) {
      min = "0" + minutes
    }
    else {
      min = minutes;
    }

    const period = this.display.substring(this.display.length - 2);
    this.normalamorpm = period;

    // if (this.normalizeTime.hour >= 12 && (this.normalamorpm == 'am' || this.normalamorpm == 'AM')) {
    //   amorpm = 'am';
    // }
    // if (this.normalizeTime.hour >= 12 && (this.normalamorpm == 'pm' || this.normalamorpm == 'PM')) {
    //   amorpm = 'pm';
    // }
    // if (hour == 12 && (this.normalamorpm == 'am' || this.normalamorpm == 'AM')) {
    //   amorpm = 'pm';
    // }
    // if (hour == 12 && (this.normalamorpm == 'pm' || this.normalamorpm == 'PM')) {
    //   amorpm = 'am';
    // }

    // if (period == 'PM' || period == 'pm') {
    //   amorpm = 'pm';
    // } else {
    //   amorpm = 'am';
    // }

    const calculateEndTime = this.calculateEndTime(this.display, this.duration);

    this.displayTotalTime = this.displayTotalTimedetails = calculateEndTime;

    // this.displayTotalTime = normalizeDisplayTime + ':' + minute + ' ' + amorpm.toUpperCase();
    // this.displayTotalTimedetails = normalizeDisplayTime + ':' + minute + ' ' + amorpm.toUpperCase();

    let previousPeriod = this.displayDetails.split(' ')[1].toLowerCase();
    let currentPeriod = this.displayTotalTime.split(' ')[1].toLowerCase();

    if (previousPeriod == 'pm' && currentPeriod == 'am') {
      this.isNextDayBooking = true;
    } else {
      this.isNextDayBooking = false;
    }

    this.dispalyTwentyFourHourTimeFormatEnd = (this.convertTo24HourFormat(this.displayTotalTime) == undefined) ? this.roundToNextSegment(this.getCurrentTime24Hour()) : this.convertTo24HourFormat(this.displayTotalTime);

    if (this.isBookingAllowed(this.display, this.displayTotalTime) === false) {
      // this.disanledButton = true; // closed for checking new message
    } else {
      // this.disanledButton = false;
      if (this.convertTo24HourFormat(this.displayTotalTimedetails) >= this.convertTo24HourFormat(this.meetingRoomEndTime)) {
        // this.disanledButton = true; // closed for checking new message
      } else {
        // this.disanledButton = false;
        if (this.convertTo24HourFormat(this.display) < this.convertTo24HourFormat(this.meetingRoomStartTime)) {
          // this.disanledButton = true; // closed for checking new message
        } else {
          if (this.displayTotalTime == '12:00 AM') {
            // this.disanledButton = true; // closed for checking new message
          } else {
            // this.disanledButton = false; // closed for checking new message
          }
        }
      }
    }

    // if (this.convertTo24HourFormat(this.displayTotalTimedetails) >= this.convertTo24HourFormat(this.meetingRoomEndTime)) {
    //   this.disanledButton = true;
    // } else {
    //   // this.disanledButton = false;
    //   if (this.convertTo24HourFormat(this.display) < this.convertTo24HourFormat(this.meetingRoomStartTime)) {
    //     this.disanledButton = true;
    //   } else {
    //     this.disanledButton = false;
    //   }
    // }

    if (this.calformatDate(this.toDate) == this.getCurrentDate()) {
      if (this.bookingTypeName == 'Hourly') {
        const result = this.isBookingTimeClashing(this.tempData, this.convertTo24HourFormat(this.display), this.convertTo24HourFormat(this.displayTotalTime), this.calformatDate(this.toDate), this.bookedByUserId);
        if (result) {
          this.disanledButton = true;
          this.messageForButtonDisable = 'A booking/blocking already exists within the selected time range. Kindly choose an alternate time(s).';
        } else {
          const isStartTimeValid = this.isStartSmallerThanEnd(this.convertTo24HourFormat(this.displayDetails), this.roundToNextSegment(this.getCurrentTime24Hour()));
          const isEndTimeValid = this.isStartSmallerThanEnd(this.convertTo24HourFormat(this.displayTotalTime), this.convertTo24HourFormat(this.meetingRoomEndTime));
          if (this.calformatDate(this.toDate) == this.getCurrentDate()) {
            if (isStartTimeValid === false) {
              this.disanledButton = true;
              this.messageForButtonDisable = 'A booking time can not be less than the current time. Kindly choose a valid time.';
            } else {
              this.disanledButton = false;
              this.messageForButtonDisable = '';
            }
          }
        }
      }
    } else {
      if (this.bookingTypeName == 'Hourly') {
        const result = this.isBookingTimeClashing(this.tempData, this.convertTo24HourFormat(this.display), this.convertTo24HourFormat(this.displayTotalTime), this.calformatDate(this.toDate), this.bookedByUserId);
        if (result) {
          this.disanledButton = true;
          this.messageForButtonDisable = 'A booking/blocking already exists within the selected time range. Kindly choose an alternate time(s).';
        } else {
          this.disanledButton = false;
          this.messageForButtonDisable = '';
        }
      }
    }

    if (this.convertTo24HourFormat(this.displayTotalTime) == this.convertTo24HourFormat(this.display)) {
      this.disanledButton = true;
      this.messageForButtonDisable = 'Please do not select the same start and end time.';
    }

    if (this.bookingTypeName == 'Hourly') {
      if (this.convertDurationToMinutes(this.duration) > Number(this.convertHoursToMinutes(this.meetingRoomDurationMax))) {
        this.disanledButton = true;
        this.messageForButtonDisable = 'The maximum booking duration for a meeting room is limited to ' + this.convertToHoursAndMinutes(this.meetingRoomDurationMax);
      }

      if (this.convertDurationToMinutes(this.duration) < Number(this.convertHoursToMinutes(this.meetingRoomDuration))) {
        this.disanledButton = true;
        this.messageForButtonDisable = 'The minimum booking duration for a meeting room is limited to ' + this.convertToHoursAndMinutes(this.meetingRoomDuration);
      }
    }
  }

  public toggleMeridian() {
    this.meridian = !this.meridian;
  }

  tempTimeConvertion(time) {
    let timeSlot = this.display;
    let a = timeSlot.split(' ')[1].toLowerCase() == 'pm' && Number(timeSlot.split(':')[0]) < 12 ? Number(timeSlot.split(':')[0]) + 12 : timeSlot.split(' ')[1].toLowerCase() == 'am' && Number(timeSlot.split(':')[0]) == 12 ? 0 : Number(timeSlot.split(':')[0]);
    // if (a == 12)
    //   a = 0;
    let b = timeSlot.split(':')[1].split(' ')[0] == '00' ? 0 : timeSlot.split(':')[1].split(' ')[0] == '45' ? 0.75 : 0.25;
    return a + b;
  }

  public prepareDataForSlot(val) {
    let data2 = { value: val, higlight: false, type: 's', bookedhiglight: false, show: false }
    if (val % 1 == 0)
      data2.type = 'b';
    else {
      if (val % 0.5 == 0)
        data2.type = 'm';
      else
        data2.type = 's';
    }
    // data2.higlight = this.backENdData.some(item => val > item[0] && val <= item[1]);

    let start = this.tempTimeConvertion('fromTime');
    let end = start + Number(1);
    if (end >= 24)
      end = end - 24;
    if (end == 0)
      end = 24;
    let selectedTimeLine = [];
    let timeline = [];
    // selectedTimeLine = this.backENdData[meetingroom.id];
    selectedTimeLine = [start, end];
    let temp = selectedTimeLine[0];
    if (temp % 1 == 0.75 || temp % 1 == 0.25)
      temp = temp - 0.25;
    temp = (temp + 0.5 > 24) ? (temp + 0.5) - 24 : (temp + 0.5);
    if (selectedTimeLine[0] % 1 == 0)
      timeline.push(temp);
    while (selectedTimeLine[1] > temp) {
      temp = ((temp + 0.5) > 24) ? (temp + 0.5) - 24 : (temp + 0.5);
      if (temp % 1 == 0.75 || temp % 1 == 0.25)
        temp = temp - 0.25;
      timeline.push(temp);
    }

    data2.higlight = timeline.some(a => a == val);

    data2.bookedhiglight = this.bookedData.some(item => val > item[0] && val <= item[1])
    if (val % 1 != 0)
      data2.show = false
    else
      data2.show = true
    if (val > 12) {
      data2.value = val - 12 + '' + 'pm'
    }
    else {
      data2.value = val + '' + 'am'
    }

    if (data2.higlight == true && data2.bookedhiglight == true)
      this.hideAllGreen = true;

    if (data2.value == '0am')
      data2.value = '12am';
    else if (data2.value == '12pm')
      data2.value = '12am';
    else if (data2.value == '12am')
      data2.value = '12pm';

    return data2
  }

  // getDatesInRangeNonOperationalDates(startDay, endDay, startDate, endDate) {
  //   const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  //   const startDateObj = new Date(startDate);
  //   const endDateObj = new Date(endDate);
  //   const startDayIndex = daysOfWeek.indexOf(startDay);
  //   const endDayIndex = daysOfWeek.indexOf(endDay);
  //   const datesInRange = [];

  //   // Iterate through each date between start date and end date
  //   for (let currentDate = startDateObj; currentDate <= endDateObj; currentDate.setDate(currentDate.getDate() + 1)) {
  //     const currentDayIndex = currentDate.getDay();

  //     // Check if the current day falls within the specified range of days
  //     if (startDayIndex <= endDayIndex) {
  //       if (currentDayIndex >= startDayIndex && currentDayIndex <= endDayIndex) {
  //         datesInRange.push(new Date(currentDate));
  //       }
  //     } else {
  //       if (currentDayIndex >= startDayIndex || currentDayIndex <= endDayIndex) {
  //         datesInRange.push(new Date(currentDate));
  //       }
  //     }
  //   }

  //   return datesInRange;
  // }

  getDatesInRangeNonOperationalDates(startDate, endDate, startDay, endDay) {
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const startDayIndex = daysOfWeek.indexOf(startDay);
    const endDayIndex = daysOfWeek.indexOf(endDay);

    // Check if all days are selected
    if (endDayIndex - startDayIndex === 6 || (startDayIndex === 0 && endDayIndex === 6)) {
      return [];
    }

    const dates = [];

    // Create Date objects for start and end dates
    let currentDate = new Date(startDate);
    const endDateTime = new Date(endDate).getTime();

    // Find the first occurrence of the start day
    // while (currentDate.getDay() !== startDayIndex) {
    //   currentDate.setDate(currentDate.getDate() + 1);
    // }

    // Loop through dates from start day to end date
    while (currentDate.getTime() <= endDateTime) {
      const currentDayIndex = currentDate.getDay();
      // If the current day is not start day or end day, and it's not between start day and end day
      if (currentDayIndex !== startDayIndex && currentDayIndex !== endDayIndex &&
        (startDayIndex < endDayIndex ? (currentDayIndex < startDayIndex || currentDayIndex > endDayIndex) : (currentDayIndex > endDayIndex && currentDayIndex < startDayIndex))) {
        // Format the date to 'YYYY-MM-DD' and push it into the dates array
        const formattedDate = currentDate.toISOString().slice(0, 10);
        // dates.push(formattedDate);
        if (formattedDate !== startDate && formattedDate !== endDate) {
          dates.push(formattedDate);
        }
      }

      // Move to the next day
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
  }

  formatDateNonOperationalDates(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getNonOperationalDates(startDate, endDate, operationFrom, operationTo) {
    const nonOperationalDates = [];
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const start = new Date(startDate);
    const end = new Date(endDate);

    const operationStartIndex = daysOfWeek.indexOf(operationFrom);
    const operationEndIndex = daysOfWeek.indexOf(operationTo);

    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      const dayOfWeekIndex = d.getDay();
      if (dayOfWeekIndex < operationStartIndex || dayOfWeekIndex > operationEndIndex) {
        nonOperationalDates.push(new Date(d));
      }
    }

    return nonOperationalDates.map(date => this.formatDateForDisable(date));
  }

  formatDateForDisable(date) {
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;

    return `${year}-${month}-${day}`;
  }

  formatDateConver(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(this.tempDate[2], this.tempDate[1] - 1, this.tempDate[0]);
    }
    else {
      this.tempDate = date.split('T')[1].split(':')
      let type = this.tempDate[0] <= 12 ? 'AM' : 'PM'
      return (this.tempDate[0] > 12) ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + type : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + type

    }
  }

  convertTimeToAMPM(timeString) {
    const [hour, minute, second] = timeString.split(':');

    let parsedHour = parseInt(hour, 10);
    const parsedMinute = parseInt(minute, 10);

    // Determine if it's AM or PM
    const period = parsedHour >= 12 ? 'PM' : 'AM';

    // Convert hour to 12-hour format
    parsedHour = parsedHour % 12 || 12;

    // Construct the formatted time string
    const formattedTime = `${parsedHour.toString().padStart(2, '0')}:${minute.padStart(2, '0')} ${period}`;

    return formattedTime;
  }

  convertTo24HourFormat(time12h) {
    // Extract hour and minute parts from the time string
    const [time, period] = time12h.split(' ');
    const [hour, minute] = time.split(':').map(part => parseInt(part, 10));

    // Adjust hour for PM
    let hour24 = hour;
    if (period === 'PM' && hour !== 12) {
      hour24 += 12;
    }

    // Adjust hour for AM and 12 PM
    if (period === 'AM' && hour === 12) {
      hour24 = 0;
    }

    // Format the hour and minute parts into 24-hour format
    const formattedHour = hour24.toString().padStart(2, '0');
    const formattedMinute = minute.toString().padStart(2, '0');

    // Return the time in 24-hour format
    return `${formattedHour}:${formattedMinute}`;
  }

  convertTo24HourFormatNew(timeString) {
    // Create a new Date object with the time string
    const date = new Date('2000-01-01 ' + timeString);

    // Use the toLocaleTimeString() method to convert the time to 24-hour format
    const time24Hour = date.toLocaleTimeString('en-US', { hour12: false });

    return time24Hour;
  }

  isTimeInRange(givenTime, startTime, endTime) {
    // Convert time strings to minutes since midnight
    const [givenHour, givenMinute] = givenTime.split(':').map(part => parseInt(part, 10));
    const givenTotalMinutes = givenHour * 60 + givenMinute;

    const [startHour, startMinute] = startTime.split(':').map(part => parseInt(part, 10));
    const startTotalMinutes = startHour * 60 + startMinute;

    const [endHour, endMinute] = endTime.split(':').map(part => parseInt(part, 10));
    const endTotalMinutes = endHour * 60 + endMinute;

    // Check if givenTime is between startTime and endTime
    return givenTotalMinutes >= startTotalMinutes && givenTotalMinutes <= endTotalMinutes;
  }

  isTimeBlocked(time, timeRanges) {
    // Convert given time to a Date object
    const givenTime = time;

    // Iterate through each time range
    for (const range of timeRanges) {
      // Convert start and end times to Date objects
      const startTime = this.convertTo24HourFormatNew(range.startTime);
      const endTime = this.convertTo24HourFormatNew(range.endTime);

      // Check if the given time falls between start and end times
      if (givenTime >= startTime && givenTime <= endTime) {
        return true; // Time falls within a blocked range
      }
    }

    return false; // Time does not fall within any blocked range
  }

  isBookingAllowed(startTime, endTime) {
    // Convert time strings to Date objects for easier comparison
    const startTimeObj = new Date(`01/01/2000 ${startTime}`);
    const endTimeObj = new Date(`01/01/2000 ${endTime}`);

    // Check if the desired time range overlaps with any existing booked slots
    for (const range of this.meetingRoomAlreadyBooked) {
      const bookedStartTime = new Date(`01/01/2000 ${range.startTime}`);
      const bookedEndTime = new Date(`01/01/2000 ${range.endTime}`);

      if (
        (startTimeObj >= bookedStartTime && startTimeObj < bookedEndTime) ||
        (endTimeObj > bookedStartTime && endTimeObj <= bookedEndTime) ||
        (startTimeObj <= bookedStartTime && endTimeObj >= bookedEndTime)
      ) {
        // There is an overlap, booking not allowed
        return false;
      }
    }

    // No overlap found, booking is allowed
    return true;
  }

  getDatesInRange(startDateStr, endDateStr) {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    const dates = [];

    // Iterate through each date from start to end
    for (let date = startDate; date <= endDate; date.setDate(date.getDate() + 1)) {
      dates.push(new Date(date)); // Push a copy of the date to the array
    }

    // Convert dates to ISO string format ('YYYY-MM-DD')
    return dates.map(date => date.toISOString().slice(0, 10));
  }

  removeDuplicateDates(dates) {
    return dates.filter((date, index, self) =>
      self.findIndex(otherDate =>
        otherDate.year === date.year && otherDate.month === date.month && otherDate.day === date.day
      ) === index
    );
  }

  getDateRangeAndFormat(startDateString, endDateString) {
    const startDate = new Date(startDateString);
    const endDate = new Date(endDateString);

    const dateRange = [];
    const currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      const formattedDate = currentDate.getFullYear() + '-' + ('0' + (currentDate.getMonth() + 1)).slice(-2) + '-' + ('0' + currentDate.getDate()).slice(-2);
      dateRange.push(formattedDate);
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dateRange;
  }

  convertToDateStrings(dateObjects) {
    return dateObjects.map(date => `${date.year}-${('0' + date.month).slice(-2)}-${('0' + date.day).slice(-2)}`);
  }

  checkForBlockedDates(bookingsDates, blockDates) {
    const blockedBookings = bookingsDates.filter(date => blockDates.includes(date));
    return blockedBookings.length > 0 ? blockedBookings : null;
  }

  onChangePurpose(event: any) {
    let name = event.target.value;

    if (name == 'Others') {
      this.reasonForOther = true;
      // this.isReasonRequired = true;
    } else {
      this.reasonForOther = false;
      // this.isReasonRequired = false;
    }

    this.myForm.get('purpose').valueChanges.subscribe((value) => {
      if (value === 'Others') {
        this.myForm.get('reason').setValidators([Validators.required]);
      } else {
        this.myForm.get('reason').clearValidators();
      }
      this.myForm.get('reason').updateValueAndValidity();
    });

    // if (name == 'Urgent Maintenance') {
    //   this.disanledButton = false;
    // } else {
    //   if (this.flagForMaintenanceChecking == 1) {
    //     this.disanledButton = true;
    //   } else {
    //     this.disanledButton = false;
    //   }
    // }

    // const matchHourly = this.bookingTypeWiseArray['Hourly'] ? this.arraysMatch(this.bookingTypeWiseArray['Hourly'], this.getDateRangeFromCalender) : "";
    // const matchDaily = this.bookingTypeWiseArray['Daily'] ? this.arraysMatch(this.bookingTypeWiseArray['Daily'], this.getDateRangeFromCalender) : "";
    // const matchCalendarBlockout = this.bookingTypeWiseArray['CalendarBlockout'] ? this.arraysMatch(this.bookingTypeWiseArray['CalendarBlockout'], this.getDateRangeFromCalender) : "";
    // const matchScheduleMaintenance = this.bookingTypeWiseArray['ScheduleMaintenance'] ? this.arraysMatch(this.bookingTypeWiseArray['ScheduleMaintenance'], this.getDateRangeFromCalender) : "";

    // let checkCurrentDateTimeExitsOrNot = this.isCurrentDateInBookingList(this.tempData);
    let latestHourlyBooking = this.getLatestHourlyBooking(this.tempData.bookingTimeLineList);

    const result = this.isTimeRangeWithinBooking(this.convertTo24HourFormat(this.display), this.convertTo24HourFormat(this.displayTotalTime), latestHourlyBooking);

    this.messageForButtonDisable = '';
    if (name == '') {
      this.disanledButton = true;
    } else {
      // if (matchHourly === true && result === true) {
      //   this.disanledButton = true;
      //   this.messageForButtonDisable = 'A booking already exists within the selected date range. Kindly choose an alternate day(s).';
      // } else if (matchDaily === true) {
      //   this.disanledButton = true;
      //   this.messageForButtonDisable = 'A booking already exists within the selected date range. Kindly choose an alternate day(s).';
      // } else if (matchCalendarBlockout === true) {
      //   this.disanledButton = true;
      //   this.messageForButtonDisable = 'The meeting room is blocked within the selected date range. Kindly choose an alternate day(s).';
      // } else if (matchScheduleMaintenance === true) {
      //   this.disanledButton = true;
      //   this.messageForButtonDisable = 'A maintenance is scheduled within the selected date range. Kindly choose an alternate day(s).';
      // } else {
      //   this.disanledButton = false;
      //   this.messageForButtonDisable = '';
      // }
      if (this.calformatDate(this.toDate) == this.getCurrentDate()) {
        if (this.bookingTypeName == 'Hourly') {
          const result = this.isBookingTimeClashing(this.tempData, this.convertTo24HourFormat(this.display), this.convertTo24HourFormat(this.displayTotalTime), this.calformatDate(this.toDate), this.bookedByUserId);
          if (result) {
            this.disanledButton = true;
            this.messageForButtonDisable = 'A booking/blocking already exists within the selected time range. Kindly choose an alternate time(s).';
          } else {
            const isStartTimeValid = this.isStartSmallerThanEnd(this.convertTo24HourFormat(this.displayDetails), this.roundToNextSegment(this.getCurrentTime24Hour()));
            const isEndTimeValid = this.isStartSmallerThanEnd(this.convertTo24HourFormat(this.displayTotalTime), this.convertTo24HourFormat(this.meetingRoomEndTime));
            if (this.calformatDate(this.toDate) == this.getCurrentDate()) {
              if (isStartTimeValid === false) {
                this.disanledButton = true;
                this.messageForButtonDisable = 'A booking time can not be less than the current time. Kindly choose a valid time.';
              } else {
                this.disanledButton = false;
                this.messageForButtonDisable = '';
              }
            }
          }
        }
      } else {
        if (this.bookingTypeName == 'Hourly') {
          const result = this.isBookingTimeClashing(this.tempData, this.convertTo24HourFormat(this.display), this.convertTo24HourFormat(this.displayTotalTime), this.calformatDate(this.toDate), this.bookedByUserId);
          if (result) {
            this.disanledButton = true;
            this.messageForButtonDisable = 'A booking/blocking already exists within the selected time range. Kindly choose an alternate time(s).';
          } else {
            this.disanledButton = false;
            this.messageForButtonDisable = '';
          }
        }
      }
    }

    if (this.convertTo24HourFormat(this.displayTotalTime) == this.convertTo24HourFormat(this.display)) {
      this.disanledButton = true;
      this.messageForButtonDisable = 'Please do not select the same start and end time.';
    }

    if (this.bookingTypeName == 'Hourly') {
      if (this.convertDurationToMinutes(this.duration) > Number(this.convertHoursToMinutes(this.meetingRoomDurationMax))) {
        this.disanledButton = true;
        this.messageForButtonDisable = 'The maximum booking duration for a meeting room is limited to ' + this.convertToHoursAndMinutes(this.meetingRoomDurationMax);
      }

      if (this.convertDurationToMinutes(this.duration) < Number(this.convertHoursToMinutes(this.meetingRoomDuration))) {
        this.disanledButton = true;
        this.messageForButtonDisable = 'The minimum booking duration for a meeting room is limited to ' + this.convertToHoursAndMinutes(this.meetingRoomDuration);
      }
    }

    // this.bookingTypeWiseArray; // main array with all type
    // this.getDateRangeFromCalender// array coming from calender
  }

  arraysMatch(array1, array2) {
    return array1.some(value => array2.includes(value));
  }

  getAllBlockDateMeetingRoom() {
    this.meetingRoomAlreadyBlockDetails = [];

    let dates = this.getCurrentAndNextWeekDates();

    this.meetingRoomAlreadyBlockDetails.push({
      parkMeetingRoomId: this.parkMeetingRoomId,
      getType: 'Confirm',
      pageNo: 1,
      size: 100,
      startDateTime: dates.current,
      endDateTime: dates.nextWeek
    });

    this.employeeService
      .getAllMeetingRoomBlockData(this.meetingRoomAlreadyBlockDetails[0])
      .subscribe((res) => {
        this.meetingRoomUserId = res?.userId;
        this.disabledAllDates.push(
          ...res.list.flatMap((data) =>
            this.getDatesInRange(
              this.formatDateSringToDate(data.startDateTime),
              this.formatDateSringToDate(data.endDateTime)
            ).map((date) => this.convertDateFormat([this.formatDateStringToDate(date)])[0])
          )
        );

        this.tempDisabledAllDatesonlyBooked.push(
          ...res.list.flatMap((data) =>
            this.getDatesInRange(
              this.formatDateSringToDate(data.startDateTime),
              this.formatDateSringToDate(data.endDateTime)
            ).map((date) => this.convertDateFormat([this.formatDateStringToDate(date)])[0])
          )
        );

        this.tempDisabledDateBookedByAdmin.push(
          ...res.list.flatMap((data) =>
            this.getDatesInRange(
              this.formatDateSringToDate(data.startDateTime),
              this.formatDateSringToDate(data.endDateTime)
            ).map((date) => this.convertDateFormat([this.formatDateStringToDate(date)])[0])
          )
        );

        this.disabledAllDates = this.removeDuplicateDates(this.disabledAllDates);
        this.tempDisabledAllDatesonlyBooked = this.removeDuplicateDates(this.tempDisabledAllDatesonlyBooked);
        this.disabledAllDatesHours = this.disabledAllDates; // changes for hourly booking

        let timeChecked = this.checkMettingEndTimeWithCurrent(this.getCurrentTimeFormatted(), this.meetingRoomEndTime);
        this.timeChecked = timeChecked;

        const isGivenDateExits = this.isDateBlocked(this.calformatDate(this.toDate), this.tempData);
        if (!isGivenDateExits && this.bookingTypeName == 'Hourly') {
          this.disabledAllDatesTemp = this.disabledAllDates;
          this.disabledAllDates = this.removeCurrentDate(this.disabledAllDates);
        }
        if (this.bookingTypeName == 'Hourly') {
          this.disabledAllDates = this.processHourlyBookings(this.tempData, this.disabledAllDates);
          this.disabledAllDates = this.removeScheduleMaintenance(this.disabledAllDates, this.tempData);
        }
      });
  }

  getCurrentAndNextWeekDates() {
    // Get the current date
    var currentDate = new Date();

    // Add 7 days to the current date
    var nextWeekDate = new Date(currentDate);
    nextWeekDate.setDate(nextWeekDate.getDate() + 122);

    // Format both dates into 'MM/dd/yyyy' format
    var formattedCurrentDate = this.formatDateCurrentDash(currentDate);
    var formattedNextWeekDate = this.formatDateCurrentDash(nextWeekDate);

    // Return both formatted dates
    return {
      current: formattedCurrentDate,
      nextWeek: formattedNextWeekDate
    };
  }

  formatDateCurrentDash(date) {
    var month = (date.getMonth() + 1).toString().padStart(2, '0');
    var day = date.getDate().toString().padStart(2, '0');
    var year = date.getFullYear();

    return year + '-' + month + '-' + day;
  }

  formatDateCurrent(date) {
    var month = (date.getMonth() + 1).toString().padStart(2, '0');
    var day = date.getDate().toString().padStart(2, '0');
    var year = date.getFullYear();

    return month + '/' + day + '/' + year;
  }

  public updateSelectedDateDaily(date: NgbDate) {

    this.blockStartDate = date.year + '-' + date.month + '-' + date.day;
    this.blockStartDate = this.datepipe.transform(this.blockStartDate, 'yyyy-MM-dd');

    const fromDateStruct: NgbDateStruct = this.convertDateFormat([this.formatDateStringToDate(this.blockStartDate)])[0];
    this.fromDate = NgbDate.from(fromDateStruct);

    const jsDate = new Date(date.year, date.month - 1, date.day);

    this.selectedDate = this.convertFormat(date.year, date.month, date.day);

    this.formatDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
  }

  public async updateSelectedToDateDaily(date: NgbDate) {

    this.blockEndDate = date.year + '-' + date.month + '-' + date.day;
    this.blockEndDate = this.datepipe.transform(this.blockEndDate, 'yyyy-MM-dd');

    const fromDateStructEnd: NgbDateStruct = this.convertDateFormat([this.formatDateStringToDate(this.blockEndDate)])[0];
    this.toDate = NgbDate.from(fromDateStructEnd);

    const jsDate = new Date(date.year, date.month - 1, date.day);

    this.selectedToDate = this.convertFormat(date.year, date.month, date.day);

    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    this.formatToDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
  }

  getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Adding 1 because January is 0
    const day = String(today.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  getCurrentTime() {
    const today = new Date();
    let hours = today.getHours();
    const minutes = String(today.getMinutes()).padStart(2, '0');
    const amOrPm = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    hours = hours % 12 || 12;

    // Ensure single digit hours are padded with a leading zero
    const formattedHours = String(hours).padStart(2, '0');

    return `${formattedHours}:${minutes} ${amOrPm}`;
  }

  convertToPaddedTime(timeString) {
    const [time, meridiem] = timeString.split(' ');
    let [hours, minutes] = time.split(':');

    hours = parseInt(hours, 10);

    // Convert hours to 12-hour format
    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours -= 12;
    }

    // Ensure hours and minutes are padded with leading zeros
    hours = String(hours).padStart(2, '0');
    minutes = String(minutes).padStart(2, '0');

    return `${hours}:${minutes} ${meridiem.toUpperCase()}`;
  }

  isTimeGreaterThan(time1, time2) {
    const date1 = new Date('2000-01-01 ' + time1);
    const date2 = new Date('2000-01-01 ' + time2);

    return date1 > date2;
  }

  filterAndGroupBookings(data) {
    const dateRangesByType = {};

    // Grouping bookings by bookingTypeName
    data.data.bookingTimeLineList.forEach(booking => {
      if (!dateRangesByType[booking.bookingTypeName]) {
        dateRangesByType[booking.bookingTypeName] = [];
      }

      // Extracting date from 'bookedStartDate'
      const startDate = new Date(booking.bookedStartDate).toISOString().split('T')[0];
      const endDate = new Date(booking.bookedEndDate).toISOString().split('T')[0];

      if (startDate === endDate) {
        // If start date and end date are the same, consider it as a single date range
        dateRangesByType[booking.bookingTypeName].push({ start: startDate, end: endDate });
      } else {
        // Otherwise, consider it as a date range between start and end date
        dateRangesByType[booking.bookingTypeName].push({ start: startDate, end: endDate });
      }
    });

    return dateRangesByType;
  }

  filterBookingByType(bookingData) {
    const bookingTypes = {};

    bookingData.bookingTimeLineList.forEach(booking => {
      const bookingType = booking.bookingTypeName;
      if (!bookingTypes[bookingType]) {
        bookingTypes[bookingType] = [];
      }
      const startDate = booking.bookedStartDate.split('T')[0];
      const endDate = booking.bookedEndDate.split('T')[0];
      bookingTypes[bookingType].push(startDate, endDate);
    });

    // Remove duplicates from arrays
    for (const type in bookingTypes) {
      bookingTypes[type] = Array.from(new Set(bookingTypes[type]));
    }

    return bookingTypes;
  }

  calformatDate(date) {
    const year = date.year;
    const month = String(date.month).padStart(2, '0');
    const day = String(date.day).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getDateRange(startDateStr, endDateStr) {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    // Array to store the dates
    const dateRange = [];

    // Iterate through the range
    let currentDate = startDate;
    while (currentDate <= endDate) {
      dateRange.push(currentDate.toISOString().split('T')[0]);
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dateRange;
  }

  getCurrentTimeFormatted(): string {
    const now = new Date();
    let hours = now.getHours();
    const minutes = now.getMinutes();
    const amOrPm = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    hours = hours % 12 || 12;

    // Ensure single digit hours are padded with a leading zero
    const formattedHours = String(hours).padStart(1, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes} ${amOrPm}`;
  }

  getCurrentTime24Hour() {
    const now = new Date();

    // Get hours and minutes
    const hours = now.getHours(); // Returns 0-23
    const minutes = now.getMinutes(); // Returns 0-59

    // Format hours and minutes as two digits
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  roundToNextSegment(currentTime) {
    const [hours, minutes] = currentTime.split(':').map(Number);

    // Calculate the current segment
    const segment = Math.floor(minutes / 15) * 15;

    // If within the current segment, round up
    const newMinutes = segment + 15 > 59 ? 0 : segment + 15;
    const newHours = newMinutes === 0 ? hours + 1 : hours;

    // Format the updated time
    return `${newHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}`;
  }

  splitTime(time12h) {
    const [time, period] = time12h.split(' '); // Split time and period (AM/PM)
    const [hours, minutes] = time.split(':'); // Split hours and minutes
    return { hours: parseInt(hours, 10), minutes: parseInt(minutes, 10), period };
  }

  addDurationToTime(currentTime, duration) {
    // Parse the current time
    const [currentHours, currentMinutes] = currentTime.split(':').map(Number);

    // Add duration to the current time
    let newMinutes = currentMinutes + duration.minute;
    let newHours = currentHours + duration.hour;

    // Adjust for overflow in minutes
    if (newMinutes >= 60) {
      newHours += Math.floor(newMinutes / 60);
      newMinutes %= 60;
    }

    // Adjust for overflow in hours (optional, if dealing with 24-hour format)
    if (newHours >= 24) {
      newHours %= 24;
    }

    // Format the updated time
    return `${newHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}`;
  }

  addOneDay(dateString) {
    const date = new Date(dateString); // Create a Date object from the string
    date.setDate(date.getDate() + 1); // Add one day
    return date.toISOString().split('T')[0]; // Format back to 'YYYY-MM-DD'
  }

  isStartSmallerThanEnd(start, end) {
    // Parse the start and end times
    const [startHours, startMinutes] = start.split(':').map(Number);
    const [endHours, endMinutes] = end.split(':').map(Number);

    // Convert times to minutes since midnight for comparison
    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;

    // Return false if start is smaller than end
    return startTotalMinutes >= endTotalMinutes;
  }

  removeCurrentDate(dates) {
    // Get the current date
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1; // Months are zero-based in JavaScript
    const currentDay = today.getDate();

    // Filter out the current date
    return dates.filter(date => {
      return !(date.year === currentYear && date.month === currentMonth && date.day === currentDay);
    });
  }

  removeCurrentDateWithDynamicDate(dates, dynamicDate) {

    const currentYear = dynamicDate.year;
    const currentMonth = dynamicDate.month; // Months are zero-based in JavaScript
    const currentDay = dynamicDate.currentDay;

    // Filter out the current date
    return dates.filter(date => {
      return !(date.year === currentYear && date.month === currentMonth && date.day === currentDay);
    });
  }

  checkMettingEndTimeWithCurrent(start: string, end: string): boolean {
    // Helper to convert 12-hour time to 24-hour format
    const to24HourFormat = (time: string): { hours: number; minutes: number } => {
      const [timePart, modifier] = time.split(' ');
      let [hours, minutes] = timePart.split(':').map(Number);

      if (modifier === 'PM' && hours !== 12) {
        hours += 12;
      } else if (modifier === 'AM' && hours === 12) {
        hours = 0;
      }

      return { hours, minutes };
    };

    // Convert both times to 24-hour format
    const start24 = to24HourFormat(start);
    const end24 = to24HourFormat(end);

    // Calculate total minutes for comparison
    const startTotalMinutes = start24.hours * 60 + start24.minutes;
    const endTotalMinutes = end24.hours * 60 + end24.minutes;

    // Check if start is less than end
    return startTotalMinutes < endTotalMinutes;
  }

  // Function to check if current date exists in the list
  isCurrentDateInBookingList(finalArray: any): boolean {
    const currentDate = new Date();

    // Format current date as YYYY-MM-DD
    const todayDateStr = currentDate.toISOString().split('T')[0];
    // Format current time as HH:MM
    const currentTimeStr = currentDate.toTimeString().slice(0, 5);

    // Check if the data structure is valid
    const bookingTimeLineList = finalArray?.bookingTimeLineList;
    if (!Array.isArray(bookingTimeLineList)) {
      return false;
    }

    for (const booking of bookingTimeLineList) {
      const bookedDateStr = booking.bookedStartDate?.split('T')[0];
      const bookedEndTime = booking.bookingTypeName === 'Hourly' ? booking.bookedEndTime?.slice(0, 5) : null;

      if (todayDateStr === bookedDateStr && bookedEndTime) {
        // Current date matches a booking date and bookingTypeName is 'Hourly'
        if (booking.bookingTypeName === 'Hourly' && currentTimeStr < bookedEndTime) {
          // Current time is less than the booked end time
          return true;
        } else {
          return false;
        }
      }
    }

    // If no condition matches, return false
    return false;
  }

  // Function to get the latest hourly booking based on the current time
  getLatestHourlyBooking(bookings) {
    const now = new Date();
    const currentTime = now.toTimeString().split(" ")[0]; // hh:mm:ss format

    // Filter bookings for "Hourly" type
    const hourlyBookings = bookings.filter(booking => booking.bookingTypeName === "Hourly");

    // Further filter bookings whose end date and time have not passed yet
    const upcomingBookings = hourlyBookings.filter(booking => {
      const bookingEndDateTime = new Date(booking.bookedEndDate);
      const [endHours, endMinutes, endSeconds] = booking.bookedEndTime.split(":").map(Number);
      bookingEndDateTime.setHours(endHours, endMinutes, endSeconds);

      return bookingEndDateTime > now;
    });

    // Sort upcoming bookings by start date and time
    upcomingBookings.sort((a, b) => {
      const startA = new Date(a.bookedStartDate).getTime();
      const startB = new Date(b.bookedStartDate).getTime();
      return startA - startB;
    });

    // Return the latest booking (first in the sorted list)
    return upcomingBookings[0] || null; // Return null if no bookings are found
  }

  isTimeRangeWithinBooking(Start, End, booking) {
    // Convert times to comparable formats (in minutes from midnight)
    const timeToMinutes = (time) => {
      const [hours, minutes] = time.split(":").map(Number);
      return hours * 60 + minutes;
    };

    const startMinutes = timeToMinutes(Start);
    const endMinutes = timeToMinutes(End);

    const bookedStartMinutes = (booking?.bookedStartTime != null) ? timeToMinutes(booking?.bookedStartTime) : this.formatAMPMToTime(this.display);
    const bookedEndMinutes = (booking?.bookedEndTime != null) ? timeToMinutes(booking?.bookedEndTime) : this.formatAMPMToTime(this.displayTotalTime);

    // Check if the ranges overlap
    return startMinutes < bookedEndMinutes && endMinutes > bookedStartMinutes;
  }

  isBookingTimeClashing(data, startTime, endTime, dateToCheck, bookedByUserId) {
    // Filter bookings into hourly and maintenance categories
    const hourlyBookings = data?.bookingTimeLineList.filter(
      (booking) => booking.bookingTypeName === "Hourly"
    );
    const maintenanceBookings = data?.bookingTimeLineList.filter(
      (booking) => booking.bookingTypeName === "ScheduleMaintenance"
    );

    // Convert times to seconds for easier comparison
    const formatTimeToSeconds = (time) => {
      const [hours, minutes] = time.split(':').map(Number);
      return hours * 3600 + minutes * 60;
    };

    const addOneDay = (date) => {
      const adjustedDate = new Date(date);
      adjustedDate.setDate(adjustedDate.getDate() + 1);
      return adjustedDate.toISOString().split("T")[0];
    };

    const startSeconds = formatTimeToSeconds(startTime);
    const endSeconds = formatTimeToSeconds(endTime);

    // Check for clashes with hourly bookings
    const isHourlyClashing = hourlyBookings.some((booking) => {
      const bookedStartDate = booking.bookedStartDate.split("T")[0];
      const bookedEndDate = booking.bookedEndDate.split("T")[0];

      if (dateToCheck < bookedStartDate || dateToCheck > bookedEndDate) {
        return false; // Current date not within booking range
      }

      let bookedStartSeconds = formatTimeToSeconds(booking.bookedStartTime);
      let bookedEndSeconds = formatTimeToSeconds(booking.bookedEndTime);

      if (dateToCheck === bookedStartDate && dateToCheck === bookedEndDate) {
        // Booking is on a single day
      } else if (dateToCheck === bookedStartDate) {
        bookedEndSeconds = 86400; // End of day
      } else if (dateToCheck === bookedEndDate) {
        bookedStartSeconds = 0; // Start of day
      } else {
        bookedStartSeconds = 0;
        bookedEndSeconds = 86400;
      }

      if (bookedByUserId === booking.userId) {
        return false; // Same user, no clash
      }

      return (
        (startSeconds >= bookedStartSeconds && startSeconds < bookedEndSeconds) ||
        (endSeconds > bookedStartSeconds && endSeconds <= bookedEndSeconds) ||
        (startSeconds <= bookedStartSeconds && endSeconds >= bookedEndSeconds)
      );
    });

    // Check for clashes with maintenance bookings
    const isMaintenanceClashing = maintenanceBookings.some((booking) => {
      const bookedStartDate = booking.bookedStartDate.split("T")[0];
      const bookedEndDate = booking.bookedEndDate.split("T")[0];

      if (dateToCheck < bookedStartDate || dateToCheck > bookedEndDate) {
        return false; // Current date not within booking range
      }

      const bookedStartSeconds = formatTimeToSeconds(booking.bookedStartTime);
      const bookedEndSeconds = formatTimeToSeconds(booking.bookedEndTime);

      return (
        (startSeconds >= bookedStartSeconds && startSeconds < bookedEndSeconds) ||
        (endSeconds > bookedStartSeconds && endSeconds <= bookedEndSeconds) ||
        (startSeconds <= bookedStartSeconds && endSeconds >= bookedEndSeconds)
      );
    });

    return isHourlyClashing || isMaintenanceClashing;
  }


  calculateEndTime(stime, duration) {
    // Parse stime into a Date object
    const [time, meridian] = stime.split(" ");
    const [hours, minutes] = time.split(":").map(Number);

    // Create a Date object with stime
    const date = new Date();
    date.setHours(meridian === "PM" && hours !== 12 ? hours + 12 : hours);
    date.setHours(meridian === "AM" && hours === 12 ? 0 : date.getHours());
    date.setMinutes(minutes);
    date.setSeconds(0);

    // Add duration
    date.setHours(date.getHours() + duration.hour);
    date.setMinutes(date.getMinutes() + duration.minute);
    date.setSeconds(date.getSeconds() + duration.second);

    // Format the new time
    const endHours = date.getHours();
    const endMinutes = date.getMinutes().toString().padStart(2, "0");
    const endMeridian = endHours >= 12 ? "PM" : "AM";
    const formattedHours = endHours % 12 || 12; // Convert to 12-hour format

    return `${formattedHours}:${endMinutes} ${endMeridian}`;
  }

  isDateBlocked(date, dataArray) {
    const bookingList = dataArray?.bookingTimeLineList || [];

    return bookingList.some(booking => {
      const bookedDate = booking.bookedStartDate.split("T")[0]; // Extract the date part
      const blockedTypes = ["CalendarBlockout", "Daily", "bookingTypeName"];
      return bookedDate === date && blockedTypes.includes(booking.bookingTypeName);
    });
  }

  formatTimeToSeconds(time) {
    if (!time.includes(":")) return null; // Invalid time format

    const parts = time.split(":");
    if (parts.length === 2) {
      return `${time}:00`; // Append :00 if seconds are missing
    }
    return time; // Already in desired format
  }

  convertToDateObject(dateString) {
    const date = new Date(dateString); // Parse the ISO string
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1, // Months are zero-based
      day: date.getDate()
    };
  }

  processHourlyBookings(data, mainArray) {
    // Filter bookings with bookingTypeName === "Hourly"
    const hourlyBookings = data?.bookingTimeLineList?.filter(
      (booking) => booking.bookingTypeName === "Hourly"
    );
    return this.filterFirstArray(mainArray, hourlyBookings);
  }

  filterFirstArray(first, second) {
    return first.filter(item => {
      // Convert bookedStartDate in second array to match the {year, month, day} format
      return !second.some(booking => {
        const bookedDate = new Date(booking.bookedStartDate);
        const bookedEndDate = new Date(booking.bookedEndDate);
        const isNonOperational = this.nonOperationalDates.some(nonOpDate =>
          nonOpDate.year === item.year &&
          nonOpDate.month === item.month &&
          nonOpDate.day === item.day
        );
        return (
          !isNonOperational &&
          (
            (item.year === bookedDate.getFullYear() &&
              item.month === bookedDate.getMonth() + 1 && // Months are zero-based
              item.day === bookedDate.getDate()) ||
            (item.year === bookedEndDate.getFullYear() &&
              item.month === bookedEndDate.getMonth() + 1 && // Months are zero-based
              item.day === bookedEndDate.getDate())
          )
        );
      });
    });
  }

  convertTo12HourFormat(dateString) {
    // Extract the time part
    const timePart = dateString.split("T")[1];

    // Extract hours and minutes
    let [hours, minutes] = timePart.split(":").map(Number);

    // Determine AM or PM
    const period = hours >= 12 ? "PM" : "AM";

    // Convert hours to 12-hour format
    hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM/PM

    // Return formatted time
    return `${hours}:${minutes.toString().padStart(2, "0")} ${period}`;
  }

  splitTime12HourFormat(time12Hour) {
    // Split the time into parts (time and period)
    const [time, period] = time12Hour.split(" "); // e.g., ["10:00", "AM"]
    const [hours, minutes] = time.split(":"); // e.g., ["10", "00"]

    // Pad hours and minutes to ensure they are always two digits
    const paddedHours = hours.padStart(2, "0");  // Ensures hours are 2 digits
    const paddedMinutes = minutes.padStart(2, "0"); // Ensures minutes are 2 digits

    // Return as an object
    return {
      hours: paddedHours,   // "10"
      minutes: paddedMinutes, // "00"
      period: period        // "AM"
    };
  }

  calculateTimeDifference(startDateTime: string, endDateTime: string): number {
    // Parse the date strings into Date objects
    const startDate: Date = new Date(startDateTime);
    const endDate: Date = new Date(endDateTime);

    // Calculate the difference in milliseconds
    const timeDifferenceMs: number = endDate.getTime() - startDate.getTime();

    // Convert the difference to hours (1 hour = 3600000 ms)
    const timeDifferenceHours: number = timeDifferenceMs / 3600000;

    // Return the difference in hours as a number
    return timeDifferenceHours;
  }

  removeScheduleMaintenance(mainArray, data) {
    // Extract all ScheduleMaintenance dates from the booking timeline
    const maintenanceDates = data?.bookingTimeLineList
      .filter(booking =>
        booking.bookingTypeName === "ScheduleMaintenance" &&
        !this.nonOperationalDates.some(nonOpDate => {
          const bookedDate = new Date(booking.bookedStartDate);
          return nonOpDate.year === bookedDate.getFullYear() &&
            nonOpDate.month === (bookedDate.getMonth() + 1) &&
            nonOpDate.day === bookedDate.getDate();
        })
      )
      .map(booking => {
        const bookedDate = new Date(booking.bookedStartDate);
        return `${bookedDate.getFullYear()}-${bookedDate.getMonth() + 1}-${bookedDate.getDate()}`;
      });

    // Filter mainArray to exclude any matching maintenance dates
    const filteredArray = mainArray.filter(date => {
      const dateString = `${date.year}-${date.month}-${date.day}`;
      return !maintenanceDates.includes(dateString);
    });

    return filteredArray;
  }

  adjustDateByOneDay(date) {
    const adjustedDate = new Date(date);
    adjustedDate.setDate(adjustedDate.getDate() + 1); // Add one day
    return adjustedDate.toISOString().split("T")[0]; // Return the new date in YYYY-MM-DD format
  }

  formatAMPMToTime(time12h) {
    // Use a regular expression to match the time and period (AM/PM)
    const match = time12h.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i);

    if (!match) {
      throw new Error("Invalid time format. Expected format: '7:00 AM' or '7:00 PM'");
    }

    let [_, hours, minutes, period] = match;

    // Convert hours to numbers
    hours = parseInt(hours, 10);

    // Adjust hours for PM or midnight (12 AM)
    if (period.toUpperCase() === "PM" && hours !== 12) {
      hours += 12;
    } else if (period.toUpperCase() === "AM" && hours === 12) {
      hours = 0;
    }

    // Format hours and minutes to always have 2 digits
    const hoursFormatted = String(hours).padStart(2, "0");
    const minutesFormatted = String(minutes).padStart(2, "0");

    // Return the 24-hour format time with seconds as "00"
    return `${hoursFormatted}:${minutesFormatted}:00`;
  }

  convertDurationToMinutes(duration) {
    // Extract hour, minute, and second; default to 0 if undefined
    const hours = Number(duration.hour || 0);
    const minutes = Number(duration.minute || 0);
    const seconds = Number(duration.second || 0);

    // Check for invalid input
    if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
      throw new Error("Invalid duration values");
    }

    // Convert duration to total minutes
    return hours * 60 + minutes + Math.floor(seconds / 60);
  }

  convertHoursToMinutes(maxBookingDuration) {
    // Convert hours to minutes
    return Math.floor(maxBookingDuration * 60);
  }

  convertToHoursAndMinutes(decimalHours) {
    const hours = Math.floor(decimalHours); // Extract the whole hours
    const minutes = Math.round((decimalHours - hours) * 60); // Calculate the remaining minutes

    if (hours === 0) {
      return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
    }
    if (minutes === 0) {
      return `${hours} hour${hours !== 1 ? 's' : ''}`;
    }
    return `${hours} hour${hours !== 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
  }
}
